import React, { useEffect, useMemo, useRef, useState } from "react";
import {  Button, Card, Col, DatePicker, Empty, Flex, FloatButton, Form, List, message, Modal, notification, Progress, Radio, Row, Segmented, Select, Space, Steps, Table, Tabs } from 'antd';
import type { TableProps, UploadFile } from 'antd';
import { BudgetDataInterface } from "../models/IBudgetData";
import { AboutResearchInterface } from "../models/IAboutResearch";
import axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { formatNumber, isDateSelected, isNull, mapTypetoName, monthcolumn, periodToString } from "./functionLater";
import { FaPenNib } from "react-icons/fa6";
import { EducationInterface } from "../models/IEducation";
import { researcherInterface } from "../models/IUserData";
import { PublishedInterface } from "../models/IPub";
import { CommentInterface, CommitteeInterface, EmployeeInFacInterface, FacilityInterface, ShowUserInterface } from "../models/IShowUser";
import { ResearchHistInterface } from "../models/IResearchHist";
import { joinedParticipantInterface } from "../models/IjoinedResearcher";
import { ImpactsInterface, OutcomeInterface, OutputInterface } from "../models/Result";
import JoditReact from "jodit-react";
import CkEditor from "./ckeditor/ckEditor";
import { Editor } from "ckeditor5";
import TextArea from "antd/es/input/TextArea";
import LoadingOverlay from 'react-loading-overlay-ts';
import { Check } from "lucide-react";
import moment from "moment";
import dayjs from 'dayjs';



interface ColumnGroup {
  title: string;
  children: { title: string,render : any }[];
}

interface ResearcherComment {
  explanation: string;
}

const educolumn : TableProps<EducationInterface>['columns']=[
    {
      title: 'ระดับปริญญา',
      dataIndex:'edu_level',
      key: 'edu_level'
  },
  {   title: 'วุฒิการศึกษา',
      dataIndex: 'edu_qual',
      key: 'edu_qual',
  },
  {
      title: 'สถาบันการศึกษา',
      dataIndex:'edu_place',
      key: 'edu_place'
  },
  {
    title: 'ปีที่สำเร็จการศึกษา',
    dataIndex:'edu_year',
    key: 'edu_year'
},
  {
      title: 'ประเทศ',
      dataIndex:'edu_country',
      key: 'edu_country'
  },
  ]

const headexcolumns: TableProps<ResearchHistInterface>['columns']=[
  {
      title: 'ปี พ.ศ.',
      dataIndex:'year',
      key: 'year'
  },
  {   title: 'ชื่อเรื่องวิจัย',
      dataIndex: 'project_name',
      key: 'project_name',
  },{
    title: 'สถานะในโครงการ',
    dataIndex: 'role',
    key: 'role',
  },
  {
      title: 'รายชื่อคณะวิจัย',
      dataIndex: 'join_project',
      key: 'join_project',
      width: 380,
      render: (_, record) => (
        <>
          {record.join_project.length != 0 &&
            <>
              <p>{record?.fullname}</p>
              {record.join_project.map((item) => (
                <><p>{item.Per_FNameTH} {item.Per_LNameTH}</p></>

              ))}</> || <><Flex justify='center'>
                <p>ไม่มีผู้ร่วมวิจัย</p></Flex>
            </>}
        </>
      ),
    },
  {
    title: 'แหล่งทุนสนับสนุน',
    dataIndex:'project_budget',
    key: 'project_budget',
    render: (_, record) => (
      <Space size="middle">
        {record.project_budget_type.inside!=null&&<p>{record.project_budget_type.inside}</p>}
        {record.project_budget_type.other!=null&&<p>{record.project_budget_type.other}</p>}
        {record.project_budget_type.student!=null&&<p>{record.project_budget_type.student}</p>}
    </Space>
    ),
},
]

const academicHis : TableProps<PublishedInterface>['columns']=[
    {
        title: 'ปีที่พิมพ์',
        dataIndex:'year',
        key: 'year'
    },{
        title: 'ชื่อบทความทางวิชาการ',
        dataIndex:'academic_name',
        key: 'academic_name'
    },{
      title: 'ชื่อบทความทางวิชาการภาษาอังกฤษ',
      dataIndex:'academic_en_name',
      key: 'academic_en_name'
  },
    {
        title: 'ประเภทสิ่งตีพิมพ์',
        dataIndex:'academic_datebase',
        key: 'academic_datebase'
    },
  ]

export function StaffBudgetReq(){
    const [Keys, setExpandedRowKeys] = useState<string[]>([]);
    const [User,setUser] = useState<researcherInterface>();
    const [open,setOpen] = useState(false);
    const [DeclineOpen,setDeclineOpen] = useState(false);
    const [openReview,setOpenReview] = useState(false)
    
    const [pass,setPass] = useState(2)
    const [wholepass,setwholepass] = useState(999)
    const commentpart1ref = useRef<Editor | null>(null);
    const [commentpart1,setcommentpart1] = useState("")


    const [researchercomment, setResearcherComment] = useState<ResearcherComment[]>([]);
    
    
    const [DataFirst,setDataFirst] = useState<AboutResearchInterface[]>([]);
    const [responsibility,setResponsibility] = useState('')
    const [tmpType,setType] = useState(2)
    
    //part2 data
    const [HeadData,setHeadData] = useState<ShowUserInterface>()
    const [eduData,seteduData] = useState<EducationInterface[]>([])
    const [resData,setresData] = useState<ResearchHistInterface[]>([])
    const [pubData,setPubData] = useState<PublishedInterface[]>([])
    //studentList
    const [Studentfile, setStudentFile] = useState<UploadFile[]>([]);

    //part3
    const importantRef = useRef<Editor | null>(null);
    const objectiveRef = useRef<Editor | null>(null);
    const benefitRef = useRef<Editor | null>(null);
    const literatureRef = useRef<Editor | null>(null);
    const IdeaRef = useRef<Editor | null>(null);
    const ResearchRef = useRef<Editor | null>(null);
    const [selectedmonth,setselectedmonth] = useState(99)
    const [endmonth,setEndMonth] = useState(99)
    const [selectedyear,setselectedyear] = useState(9999)

    //part4
    const [Output,setOutput] = useState<OutputInterface[]>([])
    const [Outcome,setOutcome] = useState<OutcomeInterface[]>([])
    const [Impacts,setImpacts] = useState<ImpactsInterface>()
    
    //part5 
    const [compensationsum,setCompensationSum] = useState(0)
    const [compensationMonetry,setCompensationMonetrySum] = useState(0)
    const [compensationPrepared,setCompensationPreparedSum] = useState(0)
    const [compensationIndirect,setCompensationIndirectSum] = useState(0)
    const [outcomesum,setOutcomeSum] = useState(0)
    const [outcomeMonetry,setOutcomeMonetrySum] = useState(0)
    const [outcomePrepared,setOutcomePreparedSum] = useState(0)
    const [outcomeIndirect,setOutcomeIndirectSum] = useState(0)
    const [itemsum,setItemnSum] = useState(0)
    const [itemMonetry,setItemMonetrySum] = useState(0)
    const [itemPrepared,setItemPreparedSum] = useState(0)
    const [itemIndirect,setItemIndirectSum] = useState(0)
    const [compensationItems, setCompensationItems] = useState<BudgetDataInterface[]>([]);
    const [OutcomeItems, setOutcomeItems] = useState<BudgetDataInterface[]>([]);
    const [ItemCost, setItemCost] = useState<BudgetDataInterface[]>([]);
    const [toolDraft,setToolDraft] = useState(false);
    const [filename,setFilename] = useState('')
    const [fileList, setFileList] = useState<UploadFile[]>([]);

    const [openfile,setOpenFile] = useState(false)
    const [previewUrl, setPreviewUrl] = useState<string | null>(null);
    const [passed,setPassed]=useState(false);
    const [commentable,setcommentable]=useState(false);
    const [showCommitteeComment,setCommitteeComment]=useState(false);
    const [showCommitteeCommentStatus,setCommitteeCommentStatus] = useState(false);
    const [last,setLast]=useState(false);
    const [checkexistparticipant,setexistparticipant] = useState(false);
    const [checkifItemExist,setItemExist] = useState(false);
    const [openMod,setopenMod]=useState(false)
    const [joinParticipant,setJoinParticipant] = useState<joinedParticipantInterface[]>([])
    const [Loading,setLoading] = useState(true);
    const [openDateMod,setOpenDateMod]=useState(false)

    const [Fac,setFac] = useState<FacilityInterface[]>([]);
    const [SelectedOp,setSelectedOp] = useState('');
    const [FacOp,setFacOp] = useState<FacilityInterface>();
    const [ResOp,setResOp] = useState<EmployeeInFacInterface[]>([]);
    
    const [commit,setcommit] = useState('');
    const [SelectedResOp,setSelectedResOp] = useState<EmployeeInFacInterface>();
    const [expireDate,setExpireDate] = useState(new Date());

    const [ShowCommittee,setShowCommittee] = useState(false);
    const [Committee,setCommittee] = useState<EmployeeInFacInterface[]>([]);
    const [Committeeandcomment,setCommitteeandcomment] = useState<CommitteeInterface[]>([])
    const [summary,setsummary] = useState<string[]>([]);
    const [exp,setexp] = useState<CommentInterface[]>([]);
    const [newDate,setNewDate] = useState(new Date());


    const [isCommitted,setCommitted] = useState(false);
    const [result,setResult] = useState('')

    const {ROCKEditors,CKEditors,getHTML} = CkEditor();
    const [form] = Form.useForm();
    const [submitform] = Form.useForm();
    
    const [StaffCommentDate,setStaffCommentDate] = useState('')
    const [explanation,setexplanation] = useState('');
    const [preview,setPreview]=useState(false)
    const location = useLocation();
    const navigate = useNavigate();
    const { project_id,user } = useParams();
    const htmlpage = useRef(null);
    const [PreviewLoading,setPreviewLoading] = useState(true);
    const [exportdata,setExportData] = useState('ss');
    
    const handleExpand = (expanded: boolean, record: any) => {
        if (expanded) {
            setExpandedRowKeys([record.id]); // Expand only the clicked row
        } else {
            setExpandedRowKeys([]); // Collapse all rows
        }
    };

    const fetchStudentFiles = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE}/Studentfiles/${project_id}`);
        const files = response.data.map((file: any) => ({
          uid: file.uid || `__AUTO__${file.uid}`, // Ensure each file has a unique uid
          name: decodeURIComponent(atob(file.Filename)), // Decode the filename
          status: 'done', // Mark the file as already uploaded
          url: `${process.env.REACT_APP_BASE}/get_pdf/${file.uid}`, 
          preview: file.Data
        }));
        setStudentFile(files);
        console.log(files)
      } catch (error) {
        console.error('Error fetching file list:', error);
      }
    };

    const handleSetEditor = async () => {
      let tmptext = `
        <h2 class="document-title">
            <strong>ข้อมูลงานวิจัยและนวัตกรรมที่กำลังยื่นของบประมาณ</strong><br>
        </h2>
        <h3 class="document-subtitle">
            <strong><u>ส่วนที่ 1 ข้อมูลงานวิจัย</u></strong><br/>
        </h3>
        <p>
            <strong>ชื่อโครงการ (ไทย) : </strong>${DataFirst[0].project_name_th}
        </p>
        <p>
            <strong>ชื่อโครงการ (อังกฤษ) : </strong>${DataFirst[0].project_name_en}
        </p>
        <p><strong>ประเภททุนของโครงการ:</strong> ${DataFirst[0]?.budget_type} </p>
        <p><strong>ประเภทของงานวิจัย :</strong> ${mapTypetoName(tmpType)} ${tmpType === 7 ? DataFirst[0]?.other_project_type || '' : ''}</p>
        <p><strong>The 17 sustainable development goals (SDGs) ที่มีความสอดคล้องกับงานวิจัย :</strong> ${DataFirst[0]?.sdgs.replace("[", "").replace("]", "")} </p>
        <p><strong>การตอบสนองต่อความต้องการของประเทศและชุมชนของงานวิจัย :</strong> ${responsibility}</p>
        <p>
          <strong>สาขาวิชาที่ทำการวิจัย :</strong> 
          ${DataFirst[0]?.oecd_type} &nbsp;&nbsp; 
          (${DataFirst[0]?.oecd_sub_type} 
          ${DataFirst[0]?.oecd_field ? `&nbsp;&nbsp;(${DataFirst[0]?.oecd_field})` : ''})
        </p>
        <p><strong>สถานที่ทำการทดลอง/เก็บข้อมูล :</strong> </p>
        <p>${DataFirst[0]?.project_place}</p>
        <br/>
        <div class="page-break" style="page-break-after:always;">
            <span style="display:none;">&nbsp;</span>
        </div>
        <h3 class="document-subtitle">
            <strong><u>ส่วนที่ 2 ข้อมูลบุคลากรที่เกี่ยวข้องกับงานวิจัย</u></strong><br/>
        </h3>
        
      `;
      if(isNull(DataFirst[0]?.pro_name)){
        tmptext+=`<p className="leading-relaxed text-s" style={{color:'Grey'}}><i>โครงการนี้ไม่มีที่ปรึกษา</i></p>`
      }else{
        tmptext+=`
                <p><strong> ที่ปรึกษา </strong></p>
                <p><strong> ชื่อ-นามสกุล :</strong> ${DataFirst[0]?.pro_name} </p>
                <p><strong> ตำแหน่งทางวิชาการ :</strong> ${DataFirst[0]?.pro_position}</p>
                <p><strong> หน่วยงานที่สังกัด :</strong> ${DataFirst[0]?.pro_wp}</p>
                <p><strong> ประสบการณ์ในการวิจัย (หรือความชำนาญในสายงาน) :</strong> ${DataFirst[0]?.pro_exp}</p>
                `
      }

      tmptext+=`
      <br/>
      <p><strong><u>ข้อมูลหัวหน้าโครงการวิจัย</strong></u></p>
      <p><strong>ชื่อภาษาไทย :</strong> ${User?.Per_PrefixTH}${User?.Per_FNameTH} ${User?.Per_LNameTH}</p>
      <p><strong>ชื่อภาษาอังกฤษ :</strong> ${User?.Per_PrefixEN}${User?.Per_FNameEN} ${User?.Per_LNameEN}</p>
      <p> <strong>สถานที่ทำงาน :</strong> ${HeadData?.head_wp}</p>
      <p> <strong>สัดส่วนการเข้าร่วมโครงการวิจัย :</strong> ${HeadData?.join_per} เปอร์เซ็นต์จากทั้งหมด</p>
      <br/>
      <p><strong>วุฒิการศึกษา</strong></p>
        <figure class="table" style="width:79.3%;">
          <table style="border-collapse: collapse; border-style: solid; width: 100%;">
              <tbody>
                  <tr>
                      <td style="border-bottom-style:solid;
                      border-color:windowtext;
                      border-left-style:solid;
                      border-right-style:solid;
                      border-top-style:solid;
                      border-width:1.0pt;padding:0cm 5.4pt;
                      vertical-align:top;">
                          ระดับปริญญา
                      </td>
                      <td style="border-bottom-style:solid;
                      border-color:windowtext;
                      border-left-style:solid;
                      border-right-style:solid;
                      border-top-style:solid;
                      border-width:1.0pt;
                      padding:0cm 5.4pt;
                      vertical-align:top;">
                          วุฒิการศึกษา
                      </td>
                      <td style="border-bottom-style:solid;
                      border-color:windowtext;
                      border-left-style:solid;
                      border-right-style:solid;
                      border-top-style:solid;
                      border-width:1.0pt;
                      padding:0cm 5.4pt;
                      vertical-align:top;">
                          สถาบันการศึกษา
                      </td>
                      <td style="border-bottom-style:solid;
                      border-color:windowtext;
                      border-left-style:solid;
                      border-right-style:solid;
                      border-top-style:solid;
                      border-width:1.0pt;
                      padding:0cm 5.4pt;
                      vertical-align:top;">
                          ปีที่สำเร็จการศึกษา
                      </td>
                      <td style="border-bottom-style:solid;
                                border-color:windowtext;
                                border-left-style:solid;
                                border-right-style:solid;
                                border-top-style:solid;
                                border-width:1.0pt;
                                padding:0cm 5.4pt;
                                vertical-align:top;">
                          ประเทศ
                      </td>
                  </tr>
      `
      for(let i = 0; i < eduData.length;i++){
        tmptext+=`<tr>
                    <td style="border-bottom-style:solid;border-color:windowtext;border-left-style:solid;border-right-style:solid;border-top-style:solid;border-width:1.0pt;padding:0cm 5.4pt;vertical-align:top;">
                        ${eduData[i].edu_level}
                    </td>
                    <td style="border-bottom-style:solid;border-color:windowtext;border-left-style:solid;border-right-style:solid;border-top-style:solid;border-width:1.0pt;padding:0cm 5.4pt;vertical-align:top;">
                        ${eduData[i].edu_qual}
                    </td>
                    <td style="border-bottom-style:solid;border-color:windowtext;border-left-style:solid;border-right-style:solid;border-top-style:solid;border-width:1.0pt;padding:0cm 5.4pt;vertical-align:top;">
                        ${eduData[i].edu_place}
                    </td>
                    <td style="border-bottom-style:solid;border-color:windowtext;border-left-style:solid;border-right-style:solid;border-top-style:solid;border-width:1.0pt;padding:0cm 5.4pt;vertical-align:top;">
                        ${eduData[i].edu_year}
                    </td>
                    <td style="border-bottom-style:solid;border-color:windowtext;border-left-style:solid;border-right-style:solid;border-top-style:solid;border-width:1.0pt;padding:0cm 5.4pt;vertical-align:top;">
                        ${eduData[i].edu_country}
                    </td>
                </tr>`
      }
      tmptext+=`</tbody>
          </table>
      </figure>
      <p><strong>ประสบการณ์ในการวิจัย</strong></p>
      <figure class="table" style="width:79.3%;">
          <table class="ck-table-resized style="width: 100%; border-collapse: collapse; border: 1px solid black;"">
              <colgroup><col style="width:16.74%;"><col style="width:17.01%;"><col style="width:15.67%;"><col style="width:22.98%;"><col style="width:27.6%;"></colgroup>
              <tbody>
                <tr>
                      <td class="style="border: 1px solid black; text-align:center;"">
                        <p style="text-align:center;">
                          ปี พ.ศ.
                        </p>
                      </td>
                      <td class="style="border: 1px solid black; text-align:center;"">
                        <p style="text-align:center;">
                          ชื่อเรื่องวิจัย
                        </p>
                      </td>
                      <td class="style="border: 1px solid black; text-align:center;"">
                        <p style="text-align:center;">
                          สถานะในโครงการ
                        </p>
                      </td>
                      <td class="style="border: 1px solid black; text-align:center;"">
                        <p style="text-align:center;">
                          รายชื่อคณะวิจัย
                        </p>
                      </td>
                  </tr>
      `
      for(let i = 0 ; i<resData.length;i++){
          tmptext+=` <tr>
            <td style="border: 1px solid black; text-align:center;">
                ${resData[i].year}
            </td>
            <td style="border: 1px solid black; text-align:center;">
              ${resData[i].project_name}
            </td>
            <td style="border: 1px solid black; text-align:center;">
              ${resData[i].role}
            </td>
            <td style="border: 1px solid black; text-align:center;">
            `
            if(resData[i].join_project.length==0){
                tmptext+=`ไม่มีผู้ร่วมวิจัย`
            }else{
              for(let j = 0 ; j<resData[i].join_project.length;j++){
                tmptext+=`${resData[i].join_project[j].Per_PrefixTH} ${resData[i].join_project[j].Per_FNameTH} ${resData[i].join_project[j].Per_LNameTH}
                <br/>`
              }
            }
            
            tmptext+=`</td>`

      }
      tmptext+=`</tbody>
          </table>
      </figure>
      <p><strong> การตีพิมพ์เผยแพร่งานวิจัย / บทความทางวิชาการ </strong></p>
      <figure class="table" style="width:79.3%;">
          <table class="ck-table-resized">
              <colgroup><col style="width:16.74%;"><col style="width:17.01%;"><col style="width:15.67%;"><col style="width:22.98%;"><col style="width:27.6%;"></colgroup>
              <tbody>
                <tr>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          ปีที่พิมพ์
                          </p>
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          ชื่อบทความทางวิชาการ
                          </p>
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          ชื่อบทความทางวิชาการภาษาอังกฤษ
                          </p>
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          ประเภทสิ่งตีพิมพ์
                          </p>
                      </td>
                  </tr>
      `
      for(let i = 0 ; i < pubData.length ; i++){
        tmptext+=`<tr>
                      <td style="border: 1px solid black; text-align:center;">
                          ${pubData[i].year}
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                          ${pubData[i].academic_name}
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                          ${pubData[i].academic_en_name}
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                          ${pubData[i].academic_datebase}
                      </td>
                  </tr>`
      }

      tmptext+=`</tbody>
          </table>
      </figure>
      <br/>
      `
      if(joinParticipant.length!=0){
        tmptext+=`<p><u><strong>ข้อมูลผู้ร่วมวิจัย</strong></u></p>`
        for(let i = 0;i<joinParticipant.length;i++){
          tmptext+=`<p><strong>รหัสผู้ร่วมวิจัย :</strong> ${joinParticipant[i].head_id}</p>
          <p><strong>ชื่อผู้ร่วมวิจัย :</strong> ${joinParticipant[i].head_name_th}</p>
          <p><strong>สถานที่ทำงาน :</strong> ${joinParticipant[i].head_wp}</p>
          <p><strong>สัดส่วนการเข้าร่วมโครงการวิจัย :</strong> ${joinParticipant[i].join_per} เปอร์เซ็นต์จากทั้งหมด</p>
          <br/>
          <p><strong>วุฒิการศึกษา</strong></p>
          <figure class="table" style="width:79.3%;">
            <table class="ck-table-resized">
                
                <tbody>
                 <tr>
                  <td style="border: 1px solid black; padding: 0cm 5.4pt; vertical-align: top; width: 16.74%;">
                    <p style="text-align:center;">ระดับปริญญา</p>
                  </td>
                  <td style="border: 1px solid black; padding: 0cm 5.4pt; vertical-align: top; width: 17.01%;">
                    <p style="text-align:center;">วุฒิการศึกษา</p>
                  </td>
                  <td style="border: 1px solid black; padding: 0cm 5.4pt; vertical-align: top; width: 15.67%;">
                    <p style="text-align:center;">สถาบันการศึกษา</p>
                  </td>
                  <td style="border: 1px solid black; padding: 0cm 5.4pt; vertical-align: top; width: 22.98%;">
                    <p style="text-align:center;">ปีที่สำเร็จการศึกษา</p>
                  </td>
                  <td style="border: 1px solid black; padding: 0cm 5.4pt; vertical-align: top; width: 27.6%;">
                    <p style="text-align:center;">ประเทศ</p>
                  </td>
                </tr>
          `
          let tmped = JSON.parse(joinParticipant[i].head_edu)
          for(let j = 0;j<JSON.parse(joinParticipant[i].head_edu).length;j++){
            tmptext+=` <tr>
                      <td style="border: 1px solid black; text-align:center;">
                          ${tmped[j].edu_level}
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                      ${tmped[j].edu_qual}
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                      ${tmped[j].edu_place}
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                      ${tmped[j].edu_year}
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                      ${tmped[j].edu_country}
                      </td>
                  </tr>`
          }
          
          tmptext+=`</tbody>
          </table>
      </figure>
      <p>
          <strong>ประสบการณ์ในการวิจัย</strong>
      </p>
      <figure class="table" style="width:79.3%;">
                <table class="ck-table-resized">
                    <colgroup><col style="width:16.74%;"><col style="width:17.01%;"><col style="width:15.67%;"><col style="width:22.98%;"><col style="width:27.6%;"></colgroup>
                    <tbody>
                      <tr>
                            <td style="border: 1px solid black; text-align:center;">
                              <p style="text-align:center;">
                                ปี พ.ศ.
                              </p>
                                </td>
                            <td style="border: 1px solid black; text-align:center;">
                              <p style="text-align:center;">
                                ชื่อเรื่องวิจัย
                              </p>
                                </td>
                            <td style="border: 1px solid black; text-align:center;">
                              <p style="text-align:center;">
                                สถานะในโครงการ
                              </p>
                                </td>
                            <td style="border: 1px solid black; text-align:center;">
                              <p style="text-align:center;">
                                รายชื่อคณะวิจัย
                              </p>
                            </td>
                        </tr>
      `
      let tmpres = JSON.parse(joinParticipant[i].head_res)
      for(let j = 0;j<JSON.parse(joinParticipant[i].head_res).length;j++ ){
        tmptext+=`
          <tr>
              <td style="border: 1px solid black; text-align:center;">
                  ${tmpres[j].year}
              </td>
              <td style="border: 1px solid black; text-align:center;">
                ${tmpres[j].project_name}
              </td>
              <td style="border: 1px solid black; text-align:center;">
                ${tmpres[j].role}
              </td>
              <td style="border: 1px solid black; text-align:center;">
        `
        if(tmpres[j].join_project.length==0){
          tmptext+=`ไม่มีผู้ร่วมวิจัย`
          
        }else{
          for(let k = 0 ; k<tmpres[j].join_project.length;k++){
            tmptext+=`<p>${tmpres[j].join_project[k].Per_PrefixTH} 
            ${tmpres[j].join_project[k].Per_FNameTH} 
            ${tmpres[j].join_project[k].Per_LNameTH}</p>`
          }
          
        }
        tmptext+=`</td>`
      }

      tmptext+=`</tbody>
          </table>
      </figure>
      <p><strong> การตีพิมพ์เผยแพร่งานวิจัย / บทความทางวิชาการ </strong></p>
      <figure class="table" style="width:79.3%;">
          <table class="ck-table-resized">
              <colgroup><col style="width:16.74%;"><col style="width:17.01%;"><col style="width:15.67%;"><col style="width:22.98%;"><col style="width:27.6%;"></colgroup>
              <tbody>
                <tr>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          ปีที่พิมพ์
                        </p>
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          ชื่อบทความทางวิชาการ
                        </p>
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          ชื่อบทความทางวิชาการภาษาอังกฤษ
                        </p>
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          ประเภทสิ่งตีพิมพ์
                        </p>
                      </td>
                  </tr>
      `
      let tmppub = JSON.parse(joinParticipant[i].head_pub)
      for(let j = 0 ; j < JSON.parse(joinParticipant[i].head_pub).length ; j++){
        tmptext+=`<tr>
                      <td style="border: 1px solid black; text-align:center;">
                          ${tmppub[j].year}
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                          ${tmppub[j].academic_name}
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                          ${tmppub[j].academic_en_name}
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                          ${tmppub[j].academic_datebase}
                      </td>
                  </tr>`
      }
      tmptext+=`</tbody>
          </table>
      </figure>`
        }
      }
      tmptext+=`
      <div class="page-break" style="page-break-after:always;">
          <span style="display:none;">&nbsp;</span>
      </div>
      <h3 class="document-subtitle">
        <strong><u>ส่วนที่ 3 รายละเอียดโครงการงานวิจัย</u></strong><br/>
      </h3>
      <p><strong>ความสำคัญ / เหตุผล / ปัญหาที่สำคัญของงานวิจัย / นิยามศัพท์เฉพาะ</strong></p>
      `
      tmptext+=DataFirst?.[0]?.resolution

      tmptext+=`
      <p><strong>วัตถุประสงค์ของงานวิจัย</strong></p>
      `
      tmptext+=DataFirst?.[0]?.objective_list

      tmptext+=`
      <p><strong>ประโยชน์ที่คาดว่าจะได้รับ</strong></p>
      `
      tmptext+=DataFirst?.[0]?.benefit

      tmptext+=`
      <p><strong>การทบทวนวรรณกรรมและผลงานวิจัยที่เกี่ยวข้อง</strong></p>
      `
      tmptext+=DataFirst?.[0]?.literacy

      tmptext+=`
      <p><strong>กรอบแนวคิดในการวิจัย</strong></p>
      `
      tmptext+=DataFirst?.[0]?.idea

      tmptext+=`
      <p><strong>ระเบียบวิธีวิจัย</strong></p>
      `
      tmptext+=DataFirst?.[0]?.solution

      tmptext+=`
      <p><strong>ระยะเวลาทำการวิจัย</strong></p>
      <p class="info-box">${DataFirst?.[0]?.period ? periodToString(DataFirst[0].period) : 'ยังไม่มีการกรอก'}</p>
      `
      const tmp_period = monthcolumn(
        selectedmonth,
        endmonth,
        DataFirst?.[0]?.period ? JSON.parse(DataFirst?.[0]?.period) : []
      ) as ColumnGroup[];
      
      let tmplength = tmp_period[0].children.length+((tmp_period.length-2)*3)+tmp_period[tmp_period.length-1].children.length
      if(tmp_period[0].children.length==2){
        tmplength = 2;
      }
      tmptext+=`
      <p><strong>แผนการดำเนินงานตลอดโครงการ</strong></p>
      <figure class="table" style="width:79.3%;">
            <table class="ck-table-resized">
                <colgroup><col style="width:16.74%;"><col style="width:17.01%;"><col style="width:15.67%;"><col style="width:22.98%;"><col style="width:27.6%;"></colgroup>
                <tbody>
                <tr>
                  <td rowspan="3">
                    <p style="text-align:center;">
                      กิจกรรมในการวิจัย
                    </p>
                  </td>
                  <td colspan="${tmplength}">
                    <p style="text-align:center;">
                      ระยะเวลาที่ทำกิจกรรม
                    </p>
                  </td>
                  <td rowspan="3">
                    <p style="text-align:center;">
                      ร้อยละของกิจกรรมในโครงการ
                    </p>
                  </td>
                </tr>
                <tr>
      `
      
      for (let i = 0; i < tmp_period.length; i++) {
        tmptext += `
        <td colspan="${tmp_period[i].children.length}">
          ${tmp_period[i].title}
        </td>
        `;
    }
      tmptext+=`</tr><tr>`
      for (let i = 0; i < tmp_period.length; i++) {
        for(let j = 0; j < tmp_period[i].children.length;j++){
          tmptext += `
          <td>
            ${tmp_period[i].children[j].title}
          </td>
        `;}
    }
      tmptext+=`</tr>`
    let period = DataFirst?.[0]?.period? JSON.parse(DataFirst?.[0]?.period): [];
    const [startyear, endyear] = [period[0].split('-')[0], period[1].split('-')[0]];
    let data_activity = DataFirst?.[0]?.activity ? JSON.parse(DataFirst[0].activity) : []
    for(let i = 0;i<data_activity.length;i++){
      tmptext+=`
        <tr>
          <td>
            <p>${data_activity[i].ActivityName}</p>
          </td>
      `
      
      for(let year = parseInt(startyear); year <= parseInt(endyear); year++){
        const isStartYear = year == parseInt(startyear);
        const isEndYear = year == parseInt(endyear);
        const start = isStartYear ? selectedmonth : 1;
        const end = isEndYear ? endmonth : 12;
        for (let month = start; month <= end; month++) {
          let x = isDateSelected(month, year, data_activity[i].Activitydate, period)
          tmptext+=`
          <td>
            ${x.props.children}
          </td>
        `
        }
       
      }

      tmptext+=`
          <td>
            <p>${data_activity[i].ActivityRatio}</p>
          </td>
      </tr>`
    }

      tmptext+=`
                </tbody>
              </table>
          </figure>
          `
      //ทำต่อ
      if(JSON.parse(DataFirst?.[0]?.needed_item).length!=0||JSON.parse(DataFirst?.[0]?.possesed_item).length!=0)
      { 
        tmptext+=`<p>อุปกรณ์การวิจัย</p>`
        if(JSON.parse(DataFirst?.[0]?.needed_item).length!=0){
          tmptext+=`
          <p>อุปกรณ์การวิจัยที่มีอยู่แล้ว</p>
          <figure class="table" style="width:79.3%;">
            <table class="ck-table-resized">
                <colgroup><col style="width:16.74%;"><col style="width:17.01%;"><col style="width:15.67%;"><col style="width:22.98%;"><col style="width:27.6%;"></colgroup>
                <tbody>
                  <tr>
                    <td style="border: 1px solid black; text-align:center;">
                      <p style="text-align:center;">
                        อันดับที่
                      </p>
                    </td>
                    <td style="border: 1px solid black; text-align:center;">
                      <p style="text-align:center;">
                        อุปกรณ์ที่ใช้
                      </p>
                    </td>
                  </tr>
                    `
          const tmp_needed_item = JSON.parse(DataFirst?.[0]?.needed_item)
          for(let i =0;i<tmp_needed_item.length;i++){
            tmptext+=`<tr>
                        <td style="border: 1px solid black; text-align:center;">
                          <p style="text-align:center;">
                            ${tmp_needed_item[i].index+1}
                          </p>
                        </td>
                        <td style="border: 1px solid black; text-align:center;">
                          <p style="text-align:center;">
                            ${tmp_needed_item[i].item}
                          </p>
                        </td>
                      </tr>
            `
          }
          tmptext+=`
                </tbody>
              </table>
          </figure>
          `
        }
        if(JSON.parse(DataFirst?.[0]?.possesed_item).length!=0){
          tmptext+=`<figure class="table" style="width:79.3%;">
          <table class="ck-table-resized">
              <colgroup><col style="width:16.74%;"><col style="width:17.01%;"><col style="width:15.67%;"><col style="width:22.98%;"><col style="width:27.6%;"></colgroup>
              <tbody>
                <tr>`
          const tmp_possesed_item = JSON.parse(DataFirst?.[0]?.possesed_item)
          for(let i =0;i<JSON.parse(DataFirst?.[0]?.possesed_item).length;i++){
            tmptext+=`
              <tr>
                        <td style="border: 1px solid black; text-align:center;">
                          ${tmp_possesed_item[i].index+1}
                        </td>
                        <td style="border: 1px solid black; text-align:center;">
                          ${tmp_possesed_item[i].item}
                        </td>
                      </tr>

            `
          }
          tmptext+=`
          </tbody>
        </table>
    </figure>
    `
        }
      }

      tmptext+=`
      <div class="page-break" style="page-break-after:always;">
        <span style="display:none;">&nbsp;</span>
    </div>
      <h3 class="document-subtitle">
        <strong><u>ส่วนที่ 4 ผลลัพธ์และผลกระทบ</u></strong><br/>
      </h3>
      <p><strong>ผลผลิตที่คาดว่าจะได้รับ</strong></p>
      <figure class="table" style="width:79.3%;">
          <table class="ck-table-resized">
              <colgroup><col style="width:16.74%;"><col style="width:17.01%;"><col style="width:15.67%;"><col style="width:22.98%;"><col style="width:27.6%;"></colgroup>
              <tbody>
                <tr>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          ผลผลิต
                        </p>
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          ประเภทผลผลิต
                        </p>
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          รายละเอียดของผลผลิต
                        </p>
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          จำนวนนำส่ง
                        </p>
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          หน่วยนับ
                        </p>
                      </td>
                  </tr>
      `

      for(let i = 0; i < Output.length;i++){
        tmptext+=`<tr>
                      <td style="border: 1px solid black; text-align:center;">
                          ${Output[i].Output_name}
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                          ${Output[i].Output_type}
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                          ${Output[i].Output_description}
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                          ${Output[i].Output_amount}
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                          ${Output[i].Output_unit}
                      </td>
                  </tr>`
      }
      tmptext+=`</tbody>
          </table>
      </figure>
      <br/>
      
      <p><strong>ผลลัพธ์ที่คาดว่าจะเกิดขึ้น</strong></p>
      <figure class="table" style="width:79.3%;">
          <table class="ck-table-resized">
              <colgroup><col style="width:16.74%;"><col style="width:17.01%;"><col style="width:15.67%;"><col style="width:22.98%;"><col style="width:27.6%;"></colgroup>
              <tbody>
                <tr>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          ผลลัพธ์ที่คาดว่าจะได้รับ
                        </p>
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          จำนวน
                          </p>
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          หน่วยนับ
                          </p>
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          รายละเอียดผลลัพธ์
                          </p>
                      </td>
                      <td style="border: 1px solid black; text-align:center;">
                        <p style="text-align:center;">
                          ผู้ใช้ประโยชน์(Users)/ผู้ได้รับผลประโยชน์(Beneficiaries)
                          </p>
                      </td>
                  </tr>
      `
      for(let i = 0; i < Outcome.length;i++){
        tmptext+=`
          <tr>
            <td style="border: 1px solid black; text-align:center;">
              ${Outcome[i].Outcome_name}
            </td>
            <td style="border: 1px solid black; text-align:center;">
              ${Outcome[i].Outcome_amount}
            </td>
            <td style="border: 1px solid black; text-align:center;">
              ${Outcome[i].Outcome_unit}
            </td>
            <td style="border: 1px solid black; text-align:center;">
              ${Outcome[i].Outcome_description}
            </td>
            <td style="border: 1px solid black; text-align:center;">
              ${Outcome[i].Outcome_Benefitor}
            </td>
            </tr>
        `
      }
      tmptext+=`</tbody>
          </table>
      </figure>
      <br/>
      `
      //แก้ไข
      if(Impacts?.academic_impacts ||
        Impacts?.social_impacts || 
        Impacts?.public_impacts ||  
        Impacts?.city_impacts || 
        Impacts?.environment_impacts || 
        Impacts?.policy_impacts || 
        Impacts?.economy_impacts){
          tmptext+=`
            <p><strong>ผลกระทบ</strong></p>
            `
        if(Impacts?.academic_impacts){
          tmptext+=`
            <p>ผลกระทบด้านวิชาการ : ${Impacts.academic_impacts}</p>
            `
        }
        if(Impacts?.social_impacts){
          tmptext+=`
          <p>ผลกระทบด้านสังคม : ${Impacts.social_impacts}</p>
          `
        }
        if(Impacts?.public_impacts){
          tmptext+=`
          <p>ผลกระทบด้านสาธารณะ : ${Impacts.public_impacts}</p>
          `
        }
        if(Impacts?.city_impacts){
          tmptext+=`
          <p>ผลกระทบด้านชุมชนและพื้นที่ : ${Impacts.city_impacts}</p>
          `
        }
        if(Impacts?.environment_impacts){
          tmptext+=`
          <p>ผลกระทบด้านสิ่งแวดล้อม : ${Impacts.environment_impacts}</p>
          `
        }
        if(Impacts?.policy_impacts){
          tmptext+=`
          <p>ผลกระทบด้านนโยบาย : ${Impacts.policy_impacts}</p>
          `
        }
        if(Impacts?.economy_impacts){
          tmptext+=`
          <p>ผลกระทบด้านเศรษฐกิจ : ${Impacts.economy_impacts}</p>
          `
        }
        
      }

      tmptext+=`
      <div class="page-break" style="page-break-after:always;">
          <span style="display:none;">&nbsp;</span>
      </div>
      <h3 class="document-subtitle">
        <strong><u>ส่วนที่ 5 งบประมาณและค่าใช้จ่าย</u></strong><br/>
      </h3>
      <p><strong>งบประมาณ</strong></p>
      
      `

      if(DataFirst[0]?.budget_type=='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'){
        tmptext+=`<p class="info-box"><strong>โครงการนี้มีทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษาจำนวน</strong> 10,000 <strong>บาทถ้วน</strong></p>`
      }else{
        tmptext+=`<figure class="table" style="width:79.3%;">
          <table class="ck-table-resized">
              <colgroup><col style="width:16.74%;"><col style="width:17.01%;"><col style="width:15.67%;"><col style="width:22.98%;"><col style="width:27.6%;"></colgroup>
              <tbody>
                <tr>
                  <td rowspan="2">
                    <p style="text-align:center;">
                      ลำดับที่
                    </p>
                  </td>
                  <td rowspan="2">
                  <p style="text-align:center;">
                      รายละเอียดประมาณการค่าใช้จ่าย
                      </p>
                  </td>
                  <td colspan="3">
                    <p style="text-align:center;">
                      งบประมาณ
                    </p>
                  </td>
                  <td  rowspan="2">
                  <p style="text-align:center;">
                      รวม
                      </p>
                  </td>
                  <td  rowspan="2">
                  <p style="text-align:center;">
                      หมายเหตุ
                      </p>
                  </td>
              </tr>
              <tr>
                  <td >
                  <p style="text-align:center;">
                      ตัวเงิน(เบิกจ่าย)</p>
                  </td>
                  <td style="border: 1px solid black; text-align:center;">
                  <p style="text-align:center;">
                      ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้</p>
                  </td>
                  <td style="border: 1px solid black; text-align:center;">
                  <p style="text-align:center;">
                      ไม่เป็นตัวเงิน(งบอ้อม)</p>
                  </td>
              </tr>`
              for(let i = 0;i<BudgetTypeCol.length;i++){
                tmptext+=`
                  <tr>
                    <td style="border: 1px solid black; text-align:center;">
                      <p style="text-align:center;">
                        ${BudgetTypeCol[i].id}</p>
                    </td>
                    <td style="border: 1px solid black; text-align:center;">
                      ${BudgetTypeCol[i].detail}
                    </td>
                    
                    <td style="border: 1px solid black; text-align:center;">
                      ${formatNumber(BudgetTypeCol[i].MonetrySum)}
                    </td>
                    <td style="border: 1px solid black; text-align:center;">
                      ${formatNumber(BudgetTypeCol[i].PreparedSum)}
                    </td>
                    <td style="border: 1px solid black; text-align:center;">
                      ${formatNumber(BudgetTypeCol[i].IndirectSum)}
                    </td>
                    <td style="border: 1px solid black; text-align:center;">
                      ${formatNumber(BudgetTypeCol[i].sum)}
                    </td>
                    <td style="border: 1px solid black; text-align:center;">
                      
                    </td>
                  </tr>
                `
                if (BudgetTypeCol[i].category === 'compensation') {
                  for (let j = 0; j < compensationItems.length; j++) {
                    const { BudgetType, Budget, BudgetDetail, budgetid, note } = compensationItems[j];
                    tmptext += `
                      <tr>
                        <td style="border: 1px solid black; text-align:center;">${BudgetTypeCol[i].id}.${Number(budgetid) + 1}</td>
                        <td style="border: 1px solid black; text-align:center;">${BudgetDetail}</td>
                    `;
                
                    // Budget allocation logic
                    let columns = { col1: 0, col2: 0, col3: 0, col4: 0 };
                    if (BudgetType === 'ตัวเงิน(เบิกจ่าย)') {
                      columns.col1 = Budget;
                      columns.col4 = Budget;
                    } else if (BudgetType === 'ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้') {
                      columns.col2 = Budget;
                      columns.col4 = Budget;
                    } else if (BudgetType === 'ไม่เป็นตัวเงิน(งบอ้อม)') { // Adjust for additional types
                      columns.col3 = Budget;
                      columns.col4 = Budget;
                    }
                
                    tmptext += `
                        <td style="border: 1px solid black; text-align:center;">${formatNumber(columns.col1)}</td>
                        <td style="border: 1px solid black; text-align:center;">${formatNumber(columns.col2)}</td>
                        <td style="border: 1px solid black; text-align:center;">${formatNumber(columns.col3)}</td>
                        <td style="border: 1px solid black; text-align:center;">${formatNumber(columns.col4)}</td>
                        <td style="border: 1px solid black; text-align:center;"><p>${note}</p></td>
                      </tr>
                    `;
                  }
                  
                } 
                else if (BudgetTypeCol[i].category === 'outcome') {
                  for (let j = 0; j < OutcomeItems.length; j++) {
                    const { BudgetType, Budget, BudgetDetail, budgetid, note } = OutcomeItems[j];
                    tmptext += `
                      <tr>
                        <td style="border: 1px solid black; text-align:center;">${BudgetTypeCol[i].id}.${Number(budgetid) + 1}</td>
                        <td style="border: 1px solid black; text-align:center;">${BudgetDetail}</td>
                    `;
                
                    // Budget allocation logic
                    let columns = { col1: 0, col2: 0, col3: 0, col4: 0 };
                    if (BudgetType === 'ตัวเงิน(เบิกจ่าย)') {
                      columns.col1 = Budget;
                      columns.col4 = Budget;
                    } else if (BudgetType === 'ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้') {
                      columns.col2 = Budget;
                      columns.col4 = Budget;
                    } else if (BudgetType === 'ไม่เป็นตัวเงิน(งบอ้อม)') { // Adjust for additional types
                      columns.col3 = Budget;
                      columns.col4 = Budget;
                    }
                
                    tmptext += `
                        <td style="border: 1px solid black; text-align:center;">${formatNumber(columns.col1)}</td>
                        <td style="border: 1px solid black; text-align:center;">${formatNumber(columns.col2)}</td>
                        <td style="border: 1px solid black; text-align:center;">${formatNumber(columns.col3)}</td>
                        <td style="border: 1px solid black; text-align:center;">${formatNumber(columns.col4)}</td>
                        <td style="border: 1px solid black; text-align:center;"><p>${note}</p></td>
                      </tr>
                    `;
                  }
                }
                
                else if (BudgetTypeCol[i].category === 'itemexpense') {
                  for (let j = 0; j < ItemCost.length; j++) {
                    const { BudgetType, Budget, BudgetDetail, budgetid, note } = ItemCost[j];
                    tmptext += `
                      <tr>
                        <td style="border: 1px solid black; text-align:center;">${BudgetTypeCol[i].id}.${Number(budgetid) + 1}</td>
                        <td style="border: 1px solid black; text-align:center;">${BudgetDetail}</td>
                    `;
                
                    // Budget allocation logic
                    let columns = { col1: 0, col2: 0, col3: 0, col4: 0 };
                    if (BudgetType === 'ตัวเงิน(เบิกจ่าย)') {
                      columns.col1 = Budget;
                      columns.col4 = Budget;
                    } else if (BudgetType === 'ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้') {
                      columns.col2 = Budget;
                      columns.col4 = Budget;
                    } else if (BudgetType === 'ไม่เป็นตัวเงิน(งบอ้อม)') { // Adjust for additional types
                      columns.col3 = Budget;
                      columns.col4 = Budget;
                    }
                
                    tmptext += `
                        <td style="border: 1px solid black; text-align:center;">${formatNumber(columns.col1)}</td>
                        <td style="border: 1px solid black; text-align:center;">${formatNumber(columns.col2)}</td>
                        <td style="border: 1px solid black; text-align:center;">${formatNumber(columns.col3)}</td>
                        <td style="border: 1px solid black; text-align:center;">${formatNumber(columns.col4)}</td>
                        <td style="border: 1px solid black; text-align:center;"><p>${note}</p></td>
                      </tr>
                    `;
                  }
                  
                }
              }
              tmptext+=`</tbody>
                  </table>
              </figure>
              <br/>`
      }
      

      tmptext+=`</tbody>
          </table>
      </figure>
      <br/>
      <p><strong>บรรณานุกรม</strong></p>`
      tmptext+=DataFirst?.[0]?.reference

      setExportData(tmptext);
      setPreviewLoading(false);
      setLoading(false);
      setPreview(true);
    };

    const fetchFiles = async () => {
        try {
          const response = await axios.get(`${process.env.REACT_APP_BASE}/files/${project_id}`);
          const files = response.data.map((file: any) => ({
            uid: file.uid || `__AUTO__${file.uid}`, // Ensure each file has a unique uid
            name: decodeURIComponent(atob(file.Filename)), // Decode the filename
            status: 'done', // Mark the file as already uploaded
            url: `${process.env.REACT_APP_BASE}/get_pdf/${file.uid}`, 
            preview: file.Data
          }));
          setFileList(files);
        } catch (error) {
          console.error('Error fetching file list:', error);
        }
      };

      const handleChange = (value: any) =>{
        setSelectedOp(value);
        const selected = Fac.find((facility) => facility.Fac_ID === value);
        if (selected) {
          setFacOp(selected);
        }
        axios.get(`https://i.vu.ac.th/digitalId/vuapiver1/vu/select_fac_worker.php?facid=${value}`)
        .then(res=>{
          setResOp(res.data)
          setSelectedResOp(undefined)
        })
      }

      const handleCommitChange = (value: any) =>{
        setcommit(value)
        const selected = ResOp.find((committee) => committee.WK_ID === value);
        if (selected) {
          setSelectedResOp(selected);
        }
      }
      const handleAdd = ()=>{
        let tmp = [...Committee]
        
        const data = {
          committee_id :  SelectedResOp?.WK_ID,
          staff_id: sessionStorage.getItem("user"),
          committee_name : SelectedResOp?.Per_PrefixTH + ' ' + SelectedResOp?.Per_FNameTH + ' ' + SelectedResOp?.Per_LNameTH,
          Fac_ID : SelectedResOp?.Fac_ID,
          Fac_Name : Fac.find((f) => f.Fac_ID === SelectedResOp?.Fac_ID)?.Fac_NameTH || ""
        }
        
        if(SelectedResOp){
          axios.post(`${process.env.REACT_APP_BASE}/setcommittee/${project_id}`,data)
          .then(response=>{
            if(response.status==200)
            tmp.push(SelectedResOp)
            setCommittee(tmp)
            setSelectedOp('')
            setcommit('')
            setFacOp(undefined)
            axios.get(`${process.env.REACT_APP_BASE}/getcommittee/${project_id}`).then(response=>{
              setCommitteeandcomment(response.data)
            })
          })
          
        }
        
      }

    let allTopics: string[] = [];
    for (let i = 0; i < Committeeandcomment.length; i++) {
        if (Committeeandcomment[i]?.comment) {
          try {
            allTopics = JSON.parse(Committeeandcomment[i].comment).map((item: any) => item.Topic);
            break; // Exit loop once we find valid comment
          } catch (e) {
            console.error(`Invalid JSON in comment at index ${i}:`, e);
          }
        }
      }
    
    const CommentSum = useMemo(() => {
      if (Committeeandcomment.length === 0) return [];
      
      return allTopics.map((topic: string, index: number) => {
        const row: Record<string, any> = {
          key: index,
          index: index + 1,
          topic,
        };
    
        let summaryComments = '';
    
        Committeeandcomment.forEach((committee, committeeIndex) => {
          const comments = committee.comment ? JSON.parse(committee.comment) : [];
          const comment = comments[index]?.Comment || '';
    
          row[`committee_${committeeIndex}`] = {
            result: committee.result || '-',
            comment,
          };
    
          if (comment) {
            summaryComments += (summaryComments ? '\n-' : '-') + comment;
          }
        });
        console.log(row)
        row.committee_summary = summaryComments;
        row.explaination = ''; // Replace or handle this properly if needed
        return row;
      });
    }, [Committeeandcomment]);
    
      

    const DownloadHandle = async (fileName: any) => {
        try {
          // Make API call to get the PDF data
          const response = await axios.get(`${process.env.REACT_APP_BASE}/get_pdf/${fileName}/${project_id}`, {
            responseType: 'blob', // This is crucial for handling binary data
          });
    
          // Create a Blob from the response
          const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
    
          // Create a URL for the Blob
          const pdfUrl = window.URL.createObjectURL(pdfBlob);
    
          // Create a link to download the PDF
          const link = document.createElement('a');
          link.href = pdfUrl;
    
          // Extract the filename from the Content-Disposition header
          const contentDisposition = response.headers['content-disposition'];
          let name = 'downloaded-file.pdf'; // Fallback filename
    
          if (contentDisposition) {
            const filenameRegex = /filename[^*=]*=((['"]).*?\2|([^;\s]*))/; 
            const matches = filenameRegex.exec(contentDisposition);
            if (matches != null && matches[1]) {
              name = matches[1].replace(/['"]/g, ''); // Remove quotes if present
            }
          }
    
          link.setAttribute('download', name); // Set the filename
    
          // Append link to body and trigger click to download
          document.body.appendChild(link);
          link.click();
    
          // Cleanup: remove link and release object URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(pdfUrl);
    
          if(response.status === 200){
            message.success('Download File successfully');
          }else{
            message.error('ERROR, Download File unsuccessfully');
          }
    
          message.success('PDF downloaded successfully!');
        } catch (error) {
          console.error('Error downloading PDF:', error);
          message.error('Failed to download PDF.');
        } finally {
          setLoading(false);
        }
        // axios.get(`${process.env.REACT_APP_BASE}/get_pdf/${fileName}/${project_id}`).then(response=>{
        //     if(response.status === 200){
        //       message.success('Download File successfully');
        //     }else{
        //       message.error('ERROR, Download File unsuccessfully');
        //     }
        //   }
        // )
        
      };

      const handlePreview = (file: UploadFile) => {
        if (file.preview && (file.preview as any).data) {
          // Access the data array from the preview buffer
          const uint8Array = new Uint8Array((file.preview as any).data);
          const blob = new Blob([uint8Array], { type: 'application/pdf' });
          const blobUrl = URL.createObjectURL(blob);
      
          setPreviewUrl(blobUrl);
          setOpenFile(true);  // Open the modal
        } else {
          console.error("Preview data not found.");
        }
      };

      const expandedRowRender = (record: any) => {
        let dataSource: readonly any[] | undefined = [];
        if (record.category === 'compensation') {
          dataSource = compensationItems;
        } else if (record.category === 'outcome') {
          dataSource = OutcomeItems;
        } else if (record.category === 'itemexpense') {
          dataSource = ItemCost;
        }
      
        return (
          <Table
            columns={[
              {
                title: '',
                width: 92,
                dataIndex: 'id',
                key: 'id',
                render: (_, record) => (
                  <Flex justify="center">
                    <p>{record.id !== 4 ? record.id : ''}</p>
                  </Flex>
                ),
              },
              {
                title: '',
                width: 450,
                dataIndex: 'BudgetDetail',
                key: 'BudgetDetail',
              },
              {
                title: '',
                width: 1000,
                children: [
                  {
                    title: '',
                    dataIndex: 'MonetrySum',
                    width:200,
                    render: (_, record) => (
                      <Flex justify="center">
                        {record.BudgetType === 'ตัวเงิน(เบิกจ่าย)'
                          ? formatNumber(record.Budget)
                          : '0'}
                      </Flex>
                    ),
                  },
                  {
                    title: '',
                    dataIndex: 'PreparedSum',
                    width:200,
                    render: (_, record) => (
                      <Flex justify="center">
                        {record.BudgetType === 'ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้'
                          ? formatNumber(record.Budget)
                          : '0'}
                      </Flex>
                    ),
                  },
                  {
                    title: '',
                    dataIndex: 'IndirectSum',
                    width:200,
                    render: (_, record) => (
                      <Flex justify="center">
                        {record.BudgetType === 'ไม่เป็นตัวเงิน(งบอ้อม)'
                          ? formatNumber(record.Budget)
                          : '0'}
                      </Flex>
                    ),
                  },
                ],
              },
              {
                title: '',
                width: 150,
                dataIndex: 'sum',
                render: (_, record) => (
                  <Flex justify="center">{formatNumber(record.Budget)}</Flex>
                ),
              },
              {
                title: '',
                dataIndex: 'note',
                key: 'note',
                render: (text) => (
                  <div style={{ maxWidth: '500px'}}>
                    {text}
                  </div>
                ),
              },
            ]}
            dataSource={dataSource}
            pagination={false}
            rowKey="budgetid"
            locale={{
              emptyText: <Empty description="ไม่มีข้อมูลรายละเอียด" />,
            }}
            showHeader={false} // Hide headers in the expanded table
          />
        );
      };

      const config = useMemo(() => ({
        toolbar: false,
        readonly:true,
        minHeight: 100,
        inline: false,
        autoResize: true,
        showCharsCounter: false,
        showWordsCounter: false,
        showPoweredBy: false,
        placeholder: 'กรุณากรอกข้อความที่นี่...',
        disableDragAndDrop: false,
        resizer: {
          forImageChangeAttributes: true, // Enable image resizing attributes
        },
        uploader: {
          insertImageAsBase64URI: true, // Insert images as base64
        },
        table: {
          allowCellSelection: true,
          allowResizeColumn: true,
          allowResizeRow: true,
          useExtraClasses: true,
          selectionCellStyle: {
            backgroundColor: '#a8d8eb', // Style for selected table cells
          },
        },
        showXPathInStatusbar: false,
        image: {
          allowResizeX: true, // Allow horizontal image resizing
          allowResizeY: true, // Allow vertical image resizing
          forImageChangeAttributes: true
        },
        style: {
            allowStyle: true // Ensure inline styles like text alignment are allowed
          }
      }), []);

      const BudgetTypeCol = [
        {
          id: 1,
          detail: 'หมวดค่าตอบแทน',
          category:'compensation',
          sum:compensationsum,
          MonetrySum:compensationMonetry,
          PreparedSum:compensationPrepared,
          IndirectSum:compensationIndirect
        },
        {
          id: 2,
          detail: 'หมวดค่าใช้จ่าย',
          category:'outcome',
          sum:outcomesum,
          MonetrySum:outcomeMonetry,
          PreparedSum:outcomePrepared,
          IndirectSum:outcomeIndirect
        },
        {
            id: 3,
            detail: 'หมวดค่าวัสดุ และอุปกรณ์',
            category:'itemexpense',
            sum:itemsum,
            MonetrySum:itemMonetry,
            PreparedSum:itemPrepared,
            IndirectSum:itemIndirect
          },
          {
            id: 4,
            detail: 'รวม',
            category:'',
            sum:Number(itemsum)+Number(outcomesum)+Number(compensationsum),
            MonetrySum:Number(compensationMonetry)+Number(outcomeMonetry)+Number(itemMonetry),
            PreparedSum:Number(compensationPrepared)+Number(outcomePrepared)+Number(itemPrepared),
            IndirectSum:Number(compensationIndirect)+Number(outcomeIndirect)+Number(itemIndirect)
          }
      ];

      
      

      //ดึงข้อมูล
    const getUserData = async()=>{
        axios.get(`${process.env.REACT_APP_API}/get-researcher-team/${user}`).then(response => {
            setUser(response.data.userResult[0])
            
        }).catch(error =>{console.log(error)})
    }
    //ดึงข้อมูลแบบ 2.0
    const getData = async()=>{
        // axios.get(`${process.env.REACT_APP_BASE}/BudgetReqInfo/${project_id}/${user}`).then(response=>{
            axios.get(`${process.env.REACT_APP_BASE}/BudgetReqInfo/${project_id}/${user}`).then(response=>{
            setDataFirst(response.data.main)

            if(response.data.main[0].budget_type=='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'){
              fetchStudentFiles();}

            setType(response.data.main[0].project_type)
            if(response.data.main[0].project_status!='รอตรวจสอบจากเจ้าหน้าที่สำนักวิจัย'){
                setcommentable(false);
                setcommentpart1(response.data.StaffComment[0].comment)
                if(response.data.StaffComment[0].date!=null){
                  setStaffCommentDate(response.data.StaffComment[0].date)
        
                }
                if(response.data.main[0].Explanation){
                  setexplanation(response.data.main[0].Explanation)
                }
                if(response.data.main[0].project_status=='สั่งแก้ไขจากเจ้าหน้าที่สำนักวิจัย'){
                    setPassed(false)
                }else{ 
                    setPassed(true)
                    
                    if(response.data.main[0].project_status=='รอผลอนุมัติจากคณะกรรมการ'){
                      setCommitteeComment(false)
                      setShowCommittee(true)
                      setPass(1)
                      setExpireDate(response.data.main[0].CommentIn)
                      axios.get(`${process.env.REACT_APP_BASE}/getcommittee/${project_id}`).then(res=>{
                        setCommitteeandcomment(res.data);
                        setCommitteeCommentStatus(true);
                      })
                    }else if(response.data.main[0].project_status=='รอการตรวจสอบผลอนุมัติจากกรรมการ'){
                      setPass(1)
                      setShowCommittee(true)
                      setCommitteeComment(true)
                      setLast(true)
                      axios.get(`${process.env.REACT_APP_BASE}/getcommittee/${project_id}`).then(res=>{
                        setCommitteeandcomment(res.data);
                        if(response.data.main[0].summary_comment){
                          let x = JSON.parse(response.data.main[0].summary_comment)
                          form.setFieldValue('summary',x.map((item: { summary: any; }) => item.summary))
                          setsummary(x.map((item: { summary: any; }) => item.summary))
                        }else{
                            if (res.data.length > 0) {
                              const allTopics = JSON.parse(res.data[0]?.comment || '[]').map((item: any) => item.Topic);
                          
                              const rows = allTopics.map((topic: string, index: number) => {
                                const row: Record<string, any> = {
                                  key: index, // Unique key for React
                                  index: index + 1, // Adding index for "ข้อ" column
                                  topic, // Adding topic for "หัวข้อ" column
                                };
                          
                                let summaryComments = ''; // Variable to store the summary of all committee comments
                          
                                // Loop through committees to populate committee-specific data
                                res.data.forEach((committee: { comment: string; result: any; }, committeeIndex: any) => {
                                  const comments = committee.comment ? JSON.parse(committee.comment) : []; // Parse comment safely
                                  const comment = comments[index]?.Comment || ''; // Safely access the comment
                          
                                  row[`committee_${committeeIndex}`] = {
                                    result: committee.result,
                                    comment,
                                  };
                          
                                  if (comment) {
                                    // Append the comment to the summary string, separated by newlines
                                    summaryComments += (summaryComments ? '\n-' : '-') + comment;
                                  }
                                });
                          
                                // Add a summary column for all committee comments
                                row.committee_summary = summaryComments;
                          
                                return row;
                              });
                          
                              setsummary(rows.map((row: { committee_summary: any; }) => row.committee_summary)); // Update summary state
                            }
                          
                        }
                      })
                    }else if(response.data.main[0].project_status=='อนุมัติ'||response.data.main[0].project_status=='ไม่อนุมัติ'||response.data.main[0].project_status=='แก้ไขตามความเห็นของกรรมการ'){
                      setPass(1)
                      setCommitted(true);
                      setShowCommittee(true)
                      setCommitteeComment(true)
                      setResult(response.data.main[0].project_status)
                      if(response.data.main[0].summary_comment){
                        let x = JSON.parse(response.data.main[0].summary_comment)
                        setsummary(x.map((item: { summary: any; }) => item.summary))
                      }
                    }else if(response.data.main[0].project_status=='รอตรวจสอบผลแก้ไขจากเจ้าหน้าที่'){
                      setPass(1)
                      setShowCommittee(true)
                      setCommitteeComment(true)
                      setLast(true)
                      axios.get(`${process.env.REACT_APP_BASE}/getcommittee/${project_id}`).then(res=>{
                        setCommitteeandcomment(res.data);
                        if(response.data.main[0].summary_comment){
                          console.log(response.data.main[0].summary_comment)
                          let x = JSON.parse(response.data.main[0].summary_comment)
                          form.setFieldValue('summary',x.map((item: { summary: any; }) => item.summary))
                          setsummary(x.map((item: { summary: any; }) => item.summary))
                          setexp(x)
                        }
                      })
                    }
                    else {
                      setShowCommittee(true)
                      setCommitteeComment(true)
                      setCommitted(true);
                      
                    }
                }
                
            }else if(response.data.main[0].project_status=='รอตรวจสอบจากเจ้าหน้าที่สำนักวิจัย'){
              setPassed(true)
              setcommentable(true);
              if(response.data.StaffComment.length>0){
                if(response.data.StaffComment[0].comment!=null){
                  setcommentpart1(response.data.StaffComment[0].comment)
                }
              }
              
            }
            if(response.data.ResearcherSummaryComment){
              if(response.data.main[0].project_status=='รอตรวจสอบผลแก้ไขจากเจ้าหน้าที่'&&JSON.parse(response.data.ResearcherSummaryComment).length>0){
                setResearcherComment(JSON.parse(response.data.ResearcherSummaryComment))
              }
            }

         

            
            
            if(response.data.main[0].response){
              let tmpres = JSON.parse(response.data.main[0].response)
              let text = tmpres.selectedchoice
              .map((choice:any) =>
                choice === "ตอบสนองต่อยุทธศาสตร์ชาติ"
                  ? tmpres.country
                    ? `${choice}(${tmpres.country}) `
                    : choice
                  : choice === "ตอบสนองต่อยุทธศาสตร์ของมหาวิทยาลัยวงษ์ชวลิตกุล"
                  ? tmpres.uni
                    ? `${choice}(${tmpres.uni}) `
                    : choice
                    : choice === "ตอบสนองต่อความต้องการของชุมชนพื้นที่"
                  ? tmpres.city
                    ? `${choice}(${tmpres.city}) `
                    : choice
                    : choice === "ตอบสนองต่อการเรียนรู้ตลอดชีวิต / สังคมผู้สูงอายุ"
                  ? tmpres.age
                    ? `${choice}(${tmpres.age}) `
                    : choice
                  : choice === "อื่นๆ"
                  ? tmpres.other
                  : choice
              )
              .join(",");
              setResponsibility(text)
              // if(tmpres.selectedchoice.includes("อื่นๆ")){
              //     const text = [...tmpres.selectedchoice.filter((choice: string) => choice !== "อื่นๆ"), tmpres.other].join(',');
              //     setResponsibility(text)
              // }else{
              //     setResponsibility(tmpres.selectedchoice.join(','))
              // }
            }
            if(response.data.main[0].output&&response.data.main[0].outcome&&response.data.main[0].impacts){
                setOutput(JSON.parse(response.data.main[0].output))
                setOutcome(JSON.parse(response.data.main[0].outcome))
                setImpacts(JSON.parse(response.data.main[0].impacts))
              }
              if(response.data.main[0].period){
                const dataperiod = JSON.parse(response.data.main[0].period)
                const datamonth = dataperiod[0].split('-')
                const datamonth2 = dataperiod[1].split('-')
                setEndMonth(Number(datamonth2[1]))
                setselectedmonth(Number(datamonth[1]))
                setselectedyear(Number(datamonth[0]))
            }
            setHeadData(response.data.head_researcher[0])
            if(response.data.head_researcher.length!=0){
                seteduData(JSON.parse(response.data.head_researcher[0].head_edu))
                setresData(JSON.parse(response.data.head_researcher[0].head_res))
                setPubData(JSON.parse(response.data.head_researcher[0].head_pub))
            }
            if(response.data.subInfo.length>0){
                setJoinParticipant(response.data.subInfo)
                setexistparticipant(true)
            }
            if (
                (Array.isArray(response.data.main[0].needed_item) && response.data.main[0].needed_item.length > 0) ||
                (Array.isArray(response.data.main[0].possesed_item) && response.data.main[0].possesed_item.length > 0)
              ) {
                setItemExist(true);
              }
            
            if(response.data.compensation&&response.data.outcome&&response.data.itemexpense){
                
                setCompensationItems(response.data.compensation)
                const totalCompensation = response.data.compensation.reduce((sum: any, item: any) => sum + item.Budget, 0);
                setCompensationSum(totalCompensation)
                const totalMonetryCompensationBudget = response.data.compensation
                    .filter((item:any) => item.BudgetType === "ตัวเงิน(เบิกจ่าย)")
                    .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setCompensationMonetrySum(totalMonetryCompensationBudget)
                const totalPreparedCompensationBudget = response.data.compensation
                    .filter((item:any) => item.BudgetType === "ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้")
                    .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setCompensationPreparedSum(totalPreparedCompensationBudget)
                const totalIndirectCompensationBudget = response.data.compensation
                    .filter((item:any) => item.BudgetType === "ไม่เป็นตัวเงิน(งบอ้อม)")
                    .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setCompensationIndirectSum(totalIndirectCompensationBudget)
            
                const totalOutcome = response.data.outcome.reduce((sum: any, item: any) => sum + item.Budget, 0);
                setOutcomeSum(totalOutcome)
                setOutcomeItems(response.data.outcome)
                const totalMonetryOutcomeBudget = response.data.outcome
                .filter((item:any) => item.BudgetType === "ตัวเงิน(เบิกจ่าย)")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setOutcomeMonetrySum(totalMonetryOutcomeBudget)
                const totalPreparedOutcomeBudget = response.data.outcome
                .filter((item:any) => item.BudgetType === "ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setOutcomePreparedSum(totalPreparedOutcomeBudget)
                const totalIndirectdOutcomeBudget = response.data.outcome
                .filter((item:any) => item.BudgetType === "ไม่เป็นตัวเงิน(งบอ้อม)")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setOutcomeIndirectSum(totalIndirectdOutcomeBudget)

                const totalItem = response.data.itemexpense.reduce((sum: any, item: any) => sum + item.Budget, 0);
                setItemnSum(totalItem)
                setItemCost(response.data.itemexpense)
                const totalMonetryItemBudget = response.data.itemexpense
                .filter((item:any) => item.BudgetType === "ตัวเงิน(เบิกจ่าย)")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setItemMonetrySum(totalMonetryItemBudget)
                const totalPreparedItemeBudget = response.data.itemexpense
                .filter((item:any) => item.BudgetType === "ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setItemPreparedSum(totalPreparedItemeBudget)
                const itemMonetrySum = response.data.itemexpense
                .filter((item:any) => item.BudgetType === "ไม่เป็นตัวเงิน(งบอ้อม)")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setItemIndirectSum(itemMonetrySum)
                
            }
            if(response.data.ToolDraft.length>0){
                setFilename(response.data.ToolDraft[0].fileName)
                setToolDraft(true)
            }

            
            
            
        }).then(()=>
          setLoading(false)
        )
        axios.get(`${process.env.REACT_APP_BASE}/getcommittee/${project_id}`).then(response=>{
          if(response.data)
          {setCommitteeandcomment(response.data)}
        })
      }

    const Draft = async()=>{
      try{
      const formData = await form.validateFields();
        // Map and structure data for backend
      const mergedData = allTopics.map((topic: string, index: number) => ({
        topic,
        summary: formData.summary[index], // Get the corresponding summary from form
      }));
      let data = {
        summary : JSON.stringify(mergedData)
      }
      axios.patch(`${process.env.REACT_APP_BASE}/draftcomment/${project_id}`,data).then(response=>
        {
          if(response.status==200){
            notification.success(
              {
                message: "บันทึกข้อมูลสำเร็จ",
              }
            )
          }
        }
        )

      }catch(error){
        notification.error({
          message: "บันทึกข้อมูลไม่สำเร็จ",
        });
      }
    }

    const submit = async()=> {
      try {
          const formData = await form.validateFields();
        
        if (Committeeandcomment.length < 1 && pass !=2) {
          throw new Error("กรุณาเพิ่มรายชื่อคณะกรรมการก่อนกดยืนยันผล");
        }

        const dateData = submitform.getFieldsValue()
    
        const x = pass === 1 ? "อนุมัติ" : "ไม่อนุมัติ";
        let data;
        
        if(last){
          let tmp;
          if(wholepass==1)
          {
            tmp = 'อนุมัติ'
          }else if(wholepass==2){
            tmp = 'ไม่อนุมัติ'
          }else if(wholepass==3){
            tmp = 'แก้ไขตามความเห็นของกรรมการ'
          }
          const mergedData = allTopics.map((topic: any, index: number) => ({
            topic,
            summary: formData.summary[index], // Use the corresponding index from the summary array
          }));
          data ={
            status : tmp,
            comment : JSON.stringify(mergedData),
            explanation : explanation
          }
          axios.post(`${process.env.REACT_APP_BASE}/summarysubmit/${project_id}`,data)
          .then(response => {
            if (response.status === 200) {
              navigate(`/VRIIS`);
            }})
        }else{
          const tmr = dateData.Expiracy ? dateData.Expiracy.clone().add(1, 'day') : null;
          data = {
            role: 'staff',
            Head_Result: x,
            CommentFromHead: commentpart1,
            ExpiredDate: tmr,
            commentator: sessionStorage.getItem("fullname"),
            commentatorID: sessionStorage.getItem("user")
          };
          axios.post(`${process.env.REACT_APP_BASE}/submitcomment/${project_id}`, data)
          .then(response => {
            if (response.status === 200) {
              navigate(`/VRIIS`);
            }
          })
          .catch(error => {
            message.error("บันทึกไม่สำเร็จ");
          });
        }
        
    
      } catch (error) {
        message.error("บันทึกไม่สำเร็จ");
      }
    }

    const EndReview = async() =>{
      let data;
      axios.post(`${process.env.REACT_APP_BASE}/endreview/${project_id}`, data)
      .then(response => {
        if (response.status === 200) {
          window.location.reload();
        }
      })
      .catch(error => {
        message.error("บันทึกไม่สำเร็จ");
      });
    }

    const OpenReviewAgain = async() =>{
      let data;
      axios.post(`${process.env.REACT_APP_BASE}/ReReview/${project_id}`, data)
      .then(response => {
        if (response.status === 200) {
          window.location.reload();
        }
      })
      .catch(error => {
        message.error("บันทึกไม่สำเร็จ");
      });

    }
    const ChangeDate = async () => {
      const selectedDate = form.getFieldValue('newReviewDate');
      const tmr = selectedDate ? selectedDate.clone().add(1, 'day') : null;
      let data = {
        newReviewDate: tmr
      };
    
      axios.post(`${process.env.REACT_APP_BASE}/changeReviewDate/${project_id}`, data)
        .then(response => {
          if (response.status === 200) {
            window.location.reload();
          }
        })
        .catch(error => {
          message.error("บันทึกไม่สำเร็จ");
        });
    };
    
    

    const getFac = async()=>{
      axios.get(`https://i.vu.ac.th/digitalId/vuapiver1/vu/select_faculty.php`).then(res=>{
        setFac(res.data.filter((fac: any) => fac.Fac_ID !== "70"));
      })
    }

    const handleEditorChange = () =>{
      setcommentpart1(getHTML(commentpart1ref))
  }

  function declingProject(){
    axios.get(`${process.env.REACT_APP_BASE}/DeclingProject/${project_id}`).then((res)=>{
      if(res.status==200){
        navigate('/VRIIS')
      }
    })
  }

  
    useEffect(()=>{
        getData();
        getUserData();
        fetchFiles();
        getFac();
    },[]);

    

    return(
      <>
        <LoadingOverlay
            active={Loading}
              spinner
              text='กำลังโหลดข้อมูล'>
        <div style={{
            padding:15
          }}>
            <h1 className="text-3xl font-semibold leading-relaxed">ข้อมูลงานวิจัยและนวัตกรรมที่กำลังยื่นของบประมาณ </h1>
            <br/>
            <hr/>
            <br/>
            <div
                id="part-1"/>
            <Card style={{ backgroundColor: '#FFDDAE' }}>

            {/* <Card style={{ backgroundColor: 'white' }}> */}
                <h2 className="text-2xl font-bold leading-relaxed"  
                style={{display: "flex",color:'#76453B'}} > <FaPenNib /> 
                ส่วนที่ 1 ข้อมูลงานวิจัย </h2>
            {/* </Card> */}
            
            <hr style={{ height: '1px', backgroundColor: '#B19470', border: 'none' }} />
            <br/>
            <Card style={{ backgroundColor: 'white' }}>
            <Row>
                <Col span={12}>
                    <p className="leading-relaxed font-semibold" >ชื่อโครงการ (ไทย) : </p>
                    <p style={{marginLeft:20}}>{DataFirst[0]?.project_name_th}</p>
                    
                </Col >
                <Col span={12}>
                    <p className="leading-relaxed font-semibold" >ชื่อโครงการ (อังกฤษ) : </p>
                    <p style={{marginLeft:20}}>{DataFirst[0]?.project_name_en}</p>
                </Col>
            </Row>
            <Flex>
            {(DataFirst[0]?.TimesSent&&DataFirst[0]?.YearsSent)&&<p><span style={{fontWeight:'bold'}}>โครงการนี้ถูกยื่นในรอบการขอทุนวิจัยและนวัตกรรมครั้งที่</span>&nbsp;<span>{DataFirst[0]?.TimesSent}/{DataFirst[0]?.YearsSent}</span></p>}
            <p className="leading-relaxed font-semibold">ประเภททุนของโครงการ:</p> &nbsp; <p>{DataFirst[0]?.budget_type} </p></Flex>
            <p className="leading-relaxed font-semibold" >ประเภทของงานวิจัย :  </p>
            <p><strong>ประเภทของงานวิจัย :</strong> {mapTypetoName(tmpType)} {tmpType === 7 ? <>: {DataFirst[0]?.other_project_type}</> || '' : ''}</p>
            <p className="leading-relaxed font-semibold">The 17 sustainable development goals (SDGs) ที่มีความสอดคล้องกับงานวิจัย : </p>
            <p className="leading-relaxed" style={{marginLeft:20}}> {DataFirst[0]?.sdgs.replace("[","").replace("]","")} </p>
            <p className="leading-relaxed font-semibold">การตอบสนองต่อความต้องการของประเทศและชุมชนของงานวิจัย :    </p>
            <p style={{marginLeft:20}}>{responsibility}</p>
            <p className="leading-relaxed font-semibold">สาขาวิชาที่ทำการวิจัย :</p> 
             <p style={{marginLeft:20}}>{DataFirst[0]?.oecd_type} &nbsp;&nbsp; ({DataFirst[0]?.oecd_sub_type} &nbsp;&nbsp;{DataFirst[0]?.oecd_field && <>({DataFirst[0]?.oecd_field})</>})</p>
            <p className="leading-relaxed font-semibold">สถานที่ทำการทดลอง/เก็บข้อมูล : </p>
            <p style={{marginLeft:20}}>{DataFirst[0]?.project_place}</p>
            </Card>
            <br/>
            </Card>
            <br/>
            <div
                id="part-2"/>
            <Card style={{ backgroundColor: '#FFDDAE' }}>
            <h2 className="text-2xl font-bold leading-relaxed"
            style={{display: "flex",color:'#76453B'}}>ส่วนที่ 2 ข้อมูลบุคลากรที่เกี่ยวข้องกับงานวิจัย </h2>
            
            <hr style={{ height: '1px', backgroundColor: '#B19470', border: 'none' }} />
            <br/>

            {isNull(DataFirst[0]?.pro_name) && 
                <>
                <p className="leading-relaxed text-s" style={{color:'Grey'}}><i>โครงการนี้ไม่มีที่ปรึกษา</i></p>
                </>
                ||
                <><Card style={{backgroundColor:'white'}}>
                <p className="leading-relaxed font-semibold"> ที่ปรึกษา : </p>
                <Flex>
                <p className="leading-relaxed font-semibold" style={{marginLeft:30}}> ชื่อ-นามสกุล : 
                  </p>&nbsp;<p className='font-normal'>{DataFirst[0]?.pro_name} </p></Flex>
                <Flex><p className="leading-relaxed font-semibold" style={{marginLeft:30}}> ตำแหน่งทางวิชาการ : 
                </p>&nbsp; <p className='font-normal'>{DataFirst[0]?.pro_position}</p></Flex>
                <Flex><p className="leading-relaxed font-semibold" style={{marginLeft:30}}> หน่วยงานที่สังกัด : 
                  </p>&nbsp;<p className='font-normal'>{DataFirst[0]?.pro_wp}</p></Flex>
                <Flex><p className="leading-relaxed font-semibold" style={{marginLeft:30}}> ประสบการณ์ในการวิจัย (หรือความชำนาญในสายงาน) : 
                  </p>&nbsp;<p className='font-normal'>{DataFirst[0]?.pro_exp}</p></Flex>
                </Card>
                </>
            }
            
            <br/>
            <Card style={{backgroundColor:'white'}}>
            {DataFirst[0]?.budget_type=='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'&&<h3 className="text-l font-semibold" style={{marginBottom:10}}><u>ข้อมูลอาจารย์ที่ปรึกษาโครงการ</u></h3>||<h3 className="text-l font-semibold" style={{marginBottom:10}}><u>ข้อมูลหัวหน้าโครงการวิจัย</u></h3>}
            <Flex><p className="leading-relaxed font-semibold">ชื่อภาษาไทย :</p>&nbsp;<p> {User?.Per_PrefixTH} {User?.Per_FNameTH} {User?.Per_LNameTH}</p></Flex>
            <Flex><p className="leading-relaxed font-semibold">ชื่อภาษาอังกฤษ :</p>&nbsp;<p> {User?.Per_PrefixEN} {User?.Per_FNameEN} {User?.Per_LNameEN}</p></Flex>
            {HeadData?.head_email&&<Flex><p className="leading-relaxed font-semibold"> email :</p>&nbsp;<p> {HeadData?.head_email}</p></Flex>}
            <Flex><p className="leading-relaxed font-semibold"> สถานที่ทำงาน :</p>&nbsp;<p> {HeadData?.head_wp}</p></Flex>
            {(DataFirst[0]?.budget_type!='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา')&&<Flex><p className="leading-relaxed font-semibold"> สัดส่วนการเข้าร่วมโครงการวิจัย :</p>&nbsp;<p> {HeadData?.join_per} เปอร์เซ็นต์จากทั้งหมด</p></Flex>}
            <br/>
            <p className="leading-relaxed font-semibold text-l" style={{marginBottom:10}}> <u>วุฒิการศึกษา</u> </p>
            <Table columns={educolumn}
            locale={{
                emptyText: (
                  <Empty description="ยังไม่มีการกรอกข้อมูลในส่วนที่ 2" /> // Default image with custom text
                ),
              }} dataSource={eduData}/>
            <p className="leading-relaxed font-semibold" style={{marginBottom:10}}><u>ประสบการณ์ในการวิจัย</u></p>
            <Table columns={headexcolumns}
            locale={{
                emptyText: (
                  <Empty description="ยังไม่มีการกรอกข้อมูลในส่วนที่ 2" /> // Default image with custom text
                ),
              }}
              dataSource={resData}
            />
            <p className="leading-relaxed font-semibold" style={{marginBottom:10}}><u> การตีพิมพ์เผยแพร่งานวิจัย / บทความทางวิชาการ </u></p>
            <Table columns={academicHis} 
            locale={{
                emptyText: (
                  <Empty description="ยังไม่มีการกรอกข้อมูลในส่วนที่ 2" /> // Default image with custom text
                ),
              }}
              dataSource={pubData}
              /></Card>
              {DataFirst[0]?.budget_type=='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'&&
                <>
                  <p className="text-2xl font-bold leading-relaxed">เอกสารแบบฟอร์มแบ่งสัดส่วนงานของผู้ร่วมทำงานวิจัยเชิงนวัตกรรม สำหรับนักศึกษา</p>
                  <List
                   style={{backgroundColor:'white'}}
                    bordered
                    dataSource={Studentfile}
                    renderItem={(file) => (
                        <List.Item
                    actions={[
                        <>
                        <Button type='link' onClick={() => DownloadHandle(file.uid)}>Download</Button>
                        </>
                    ]}
                    >
                    <Button type='link' 
                    onClick={() => handlePreview(file)}>{file.name}</Button>
                    
                    <Modal
                    onCancel={()=>setOpenFile(false)}
                    style={{ width: '100wh', height: 500 }}
                        open={openfile}
                        footer={<><Button onClick={()=>setOpenFile(false)} >ปิด</Button></>}
                    >
                        {previewUrl ? (
                        <iframe
                            src={previewUrl}
                            width="100%"
                            height="600px"
                            title="PDF Viewer"
                        />
                        ) : (
                        <p>Loading...</p>
                        )}
                        
                    </Modal>
                    </List.Item>
                    )}
                  />
                </>||<>
                {checkexistparticipant &&
                  <>
                  <br/>
                  <Card style={{backgroundColor:'white'}}>
                  <h3 className="text-l font-semibold" style={{marginBottom:10}}><u>ข้อมูลผู้ร่วมวิจัย</u></h3>
                  
                  <Tabs>
                  {joinParticipant.map((data,index)=>(
                <Tabs.TabPane tab={`ผู้ร่วมวิจัยคนที่ ${index+1}`} key={index}>
                  <Flex><p className='font-semibold'>รหัสผู้ร่วมวิจัย : </p>&nbsp;<p>{data.head_id}</p></Flex>
                  <Flex><p className='font-semibold'>ชื่อผู้ร่วมวิจัย :</p>&nbsp;<p></p>&nbsp;<p> {data.head_name_th}</p></Flex>
                  <Flex><p className='font-semibold'>สถานที่ทำงาน :</p>&nbsp;<p> {data.head_wp}</p></Flex>
                  <Flex><p className='font-semibold'>สัดส่วนการเข้าร่วมโครงการวิจัย :</p>&nbsp;<p> {data.join_per}</p></Flex>
                  <br/>
                  <p className="font-semibold" style={{marginBottom:10}}><u>วุฒิการศึกษา</u></p>
                  <Table columns={[
                          {
                            title: 'ระดับปริญญา',
                            dataIndex:'edu_level',
                            key: 'edu_level',
                            
                        },
                        {   title: 'วุฒิการศึกษา',
                            dataIndex: 'edu_qual',
                            key: 'edu_qual',
                            
                        },
                        {
                            title: 'สถาบันการศึกษา',
                            dataIndex:'edu_place',
                            key: 'edu_place',
                            
                        },
                        {
                          title: 'ปีที่สำเร็จการศึกษา',
                          dataIndex:'edu_year',
                          key: 'edu_year',
                          
                      },
                        {
                            title: 'ประเทศ',
                            dataIndex:'edu_country',
                            key: 'edu_country'
                            ,
                        },
                        ]} 
                        locale={{
                          emptyText: (
                            <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
                          ),
                        }}
                        dataSource={JSON.parse(data.head_edu)}/>
                        <br/>
                      <p className="leading-relaxed font-semibold" style={{marginBottom:10}}><u>ประสบการณ์ในการวิจัย</u></p>
                      <Table columns={headexcolumns} dataSource={JSON.parse(data.head_res)}
                      locale={{
                          emptyText: (
                            <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
                          ),
                        }}/>
                      <br/>
                      <p className="leading-relaxed font-semibold" style={{marginBottom:10}}><u>การตีพิมพ์เผยแพร่งานวิจัย / บทความทางวิชาการ </u></p>
                      <Table columns={academicHis} dataSource={JSON.parse(data.head_pub)}
                      locale={{
                          emptyText: (
                            <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
                          ),
                        }}/>
                      <br/>
                </Tabs.TabPane>
                    ))

                    }</Tabs>
                </Card>
                  </>
                }
              </>}
                <br/>
              <br/>
              </Card>
              <br/>
              <div
                id="part-3"/>
              <Card style={{ backgroundColor: '#FFDDAE' }}>
             <h2 className="text-2xl font-bold leading-relaxed" style={{display: "flex",color:'#76453B'}}>ส่วนที่ 3 รายละเอียดโครงการงานวิจัย</h2>
                <hr style={{ height: '1px', backgroundColor: '#B19470', border: 'none' }} />
                <br/>
                <Card style={{backgroundColor:'white'}}>
                <p className="leading-relaxed font-semibold"><u>ความสำคัญ / เหตุผล / ปัญหาที่สำคัญของงานวิจัย / นิยามศัพท์เฉพาะ</u></p>
                <Card className="transparent-border-card">
                <ROCKEditors
                  myRef={importantRef}
                  htmlBox={DataFirst?.[0]?.resolution ? DataFirst?.[0]?.resolution : "ยังไม่มีการกรอก"}
                  toolstate={false}
                  />

                </Card>
                <br/>
            <p className="leading-relaxed font-semibold" style={{marginBottom:15}}><u>วัตถุประสงค์ของงานวิจัย</u></p>
            <ROCKEditors
              myRef={objectiveRef}
              htmlBox={DataFirst?.[0]?.objective_list ? DataFirst?.[0]?.objective_list : "ยังไม่มีการกรอก"}
              toolstate={false}
              />
            <br/>
            <p className="leading-relaxed font-semibold" style={{marginBottom:15}}><u>ประโยชน์ที่คาดว่าจะได้รับ</u></p>
            <ROCKEditors
              myRef={benefitRef}
              htmlBox={DataFirst?.[0]?.benefit ? DataFirst?.[0]?.benefit : "ยังไม่มีการกรอก"}
              toolstate={false}
              />
            <p className="leading-relaxed font-semibold"><u>การทบทวนวรรณกรรมและผลงานวิจัยที่เกี่ยวข้อง</u></p>
            <Card className="transparent-border-card">
            <ROCKEditors
              myRef={literatureRef}
              htmlBox={DataFirst?.[0]?.literacy ? DataFirst?.[0]?.literacy : "ยังไม่มีการกรอก"}
              toolstate={false}
              />
            </Card>
            <p className="leading-relaxed font-semibold"><u>กรอบแนวคิดในการวิจัย</u></p>
            <Card className="transparent-border-card">
            <ROCKEditors
              myRef={IdeaRef}
              htmlBox={DataFirst?.[0]?.idea ? DataFirst?.[0]?.idea : "ยังไม่มีการกรอก"}
              toolstate={false}
              /></Card>
            <p className="leading-relaxed  font-semibold"><u>ระเบียบวิธีวิจัย</u></p>
            <Card className="transparent-border-card">
            <ROCKEditors
              myRef={ResearchRef}
              htmlBox={DataFirst?.[0]?.solution ? DataFirst?.[0]?.solution : "ยังไม่มีการกรอก"}
              toolstate={false}
              /></Card>
            <p className="leading-relaxed font-semibold" style={{marginBottom:15}}><u>ระยะเวลาทำการวิจัย</u></p>
            <Card style={{marginBottom:15}}>{DataFirst?.[0]?.period ? periodToString(DataFirst[0].period) : 'ยังไม่มีการกรอกค่า'}</Card>
            <p className="leading-relaxed font-semibold" style={{marginBottom:15}}><u>แผนการดำเนินงานตลอดโครงการ</u></p>
            <Table 
                columns={[{
                    title:'กิจกรรมในการวิจัย',
                    dataIndex:'ActivityName',
                    fixed: 'left',  
                    width: 200,  
                    className: 'fixed-column'
                },
                {
                title:'ระยะเวลาที่ทำกิจกรรม',
                children:monthcolumn(selectedmonth,endmonth,DataFirst?.[0]?.period? JSON.parse(DataFirst?.[0]?.period): [])
            },
            {
                title:'ร้อยละของกิจกรรมในโครงการ',
                dataIndex:'ActivityRatio',
                fixed: 'right',  
                width: 200, 
                className: 'fixed-column'
            },
            
            ]}
            style={{ backgroundColor: '#fff', padding: '20px' }}
            scroll={{ x: 'max-content' }}
            dataSource={DataFirst?.[0]?.activity ? JSON.parse(DataFirst[0].activity) : []}
            locale={{
                emptyText: (
                <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
                ),
            }}
            />
            <br/>
                <><p className="leading-relaxed font-semibold"><u>อุปกรณ์การวิจัย</u></p><br /><p className="leading-relaxed">อุปกรณ์ที่จำเป็นในงานวิจัย</p><Table columns={[
                        {
                            title: 'อันดับที่',
                            dataIndex: 'index',
                            width: '110px',
                            render: (_, record) => (
                                <>
                                  <p>{record.index+1}</p>
                                </>
                              ),
                        }, {
                            title: 'อุปกรณ์ที่ใช้',
                            dataIndex: 'item'
                        },
                    ]}
                        locale={{
                            emptyText: (
                                <Empty description="ไม่มีอุปกรณ์ที่จำเป็นในการวิจัยนี้" /> // Default image with custom text
                            ),
                        }}
                        dataSource={DataFirst?.[0]?.needed_item ? JSON.parse(DataFirst[0].needed_item) : []} 
                        /><br />
                        <p className="leading-relaxed">อุปกรณ์การวิจัยที่มีอยู่แล้ว</p><Table columns={[
                            {
                                title: 'อันดับที่',
                                dataIndex: 'index',
                                width: '110px',
                                render: (_, record) => (
                                    <>
                                        <p>{record.index + 1}</p>
                                    </>
                                ),
                            }, {
                                title: 'อุปกรณ์ที่ใช้',
                                dataIndex: 'item'
                            },
                        ]}
                            locale={{
                                emptyText: (
                                    <Empty description="ไม่มีอุปกรณ์วิจัยในงานวิจัยนี้" /> // Default image with custom text
                                ),
                            }}
                            dataSource={DataFirst?.[0]?.possesed_item ? JSON.parse(DataFirst[0].possesed_item) : []} /></>
            <br/>
            </Card>

            <br/>
            
            </Card>
            <div
                id="part-4"/>
            <br/>
            <Card style={{ backgroundColor: '#FFDDAE' }}>
            <h2 className="text-2xl font-bold leading-relaxed" style={{display: "flex",color:'#76453B'}}>ส่วนที่ 4 ผลลัพธ์และผลกระทบ </h2>
            <br/><hr style={{ height: '1px', backgroundColor: '#B19470', border: 'none' }} /><br/>
            <Card style={{backgroundColor:'white'}}>
            <p className="leading-relaxed font-semibold">ผลผลิตที่คาดว่าจะได้รับ</p>
            <Table columns={[
                {
                    title: 'ผลผลิต',
                    dataIndex:'Output_name',
                    key: 'Output_name'
                },
                {
                    title: 'ประเภทผลผลิต',
                    dataIndex:'Output_type',
                    key: 'Output_type'
                },
                {
                    title: 'รายละเอียดของผลผลิต',
                    dataIndex:'Output_description',
                    key: 'Output_description'
                },
                {
                    title: 'จำนวนนำส่ง',
                    dataIndex:'Output_amount',
                    key: 'Output_amount'
                },
                {
                    title: 'หน่วยนับ',
                    dataIndex:'Output_unit',
                    key: 'Output_unit'
                },
                ]}
                locale={{
                    emptyText: (
                      <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
                    ),
                  }}
                dataSource={Output}

                />
                <br/>
            <p className="leading-relaxed  font-semibold">ผลลัพธ์ที่คาดว่าจะเกิดขึ้น</p>
            <Table columns={[
                {
                    title: 'ผลลัพธ์ที่คาดว่าจะได้รับ',
                    dataIndex:'Outcome_name',
                    key: 'Outcome_name'
                },
                {
                    title: 'จำนวน',
                    dataIndex:'Outcome_amount',
                    key: 'Outcome_amount'
                },
                {
                    title: 'หน่วยนับ',
                    dataIndex:'Outcome_unit',
                    key: 'Outcome_unit'
                },
                {
                    title: 'รายละเอียดผลลัพธ์',
                    dataIndex:'Outcome_description',
                    width:500,
                    key: 'Outcome_description'
                },
                {
                    title: 'ผู้ใช้ประโยชน์(Users)/ผู้ได้รับผลประโยชน์(Beneficiaries)',
                    dataIndex:'Outcome_Benefitor',
                    key: 'Outcome_Benefitor'
                },
                ]}
                locale={{
                    emptyText: (
                      <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
                    ),
                  }}
                dataSource={Outcome}

            />
            <br/>
            <Card className='transparent-border-card'>
            <p className="font-semibold"><u>ผลกระทบ</u></p>
            
            {Impacts?.academic_impacts&&<><p className='font-semibold'>ผลกระทบด้านวิชาการ : </p><Card><p className='font-normal'>{Impacts.academic_impacts}</p></Card></>}
            {Impacts?.social_impacts&&<><p className='font-semibold'>ผลกระทบด้านสังคม : </p><Card><p className='font-normal'>{Impacts.social_impacts}</p></Card></>}
            {Impacts?.public_impacts&&<><p className='font-semibold'>ผลกระทบด้านสาธารณะ : </p><Card><p className='font-normal'>{Impacts.public_impacts}</p></Card></>}
            {Impacts?.city_impacts&&<><p className='font-semibold'>ผลกระทบด้านชุมชนและพื้นที่ : </p><Card><p className='font-normal'>{Impacts.city_impacts}</p></Card></>}
            {Impacts?.environment_impacts&&<><p className='font-semibold'>ผลกระทบด้านสิ่งแวดล้อม : </p><Card><p className='font-normal'>{Impacts.environment_impacts}</p></Card></>}
            {Impacts?.policy_impacts&&<><p className='font-semibold'>ผลกระทบด้านนโยบาย : </p><Card><p className='font-normal'>{Impacts.policy_impacts}</p></Card></>}
            {Impacts?.economy_impacts&&<><p className='font-semibold'>ผลกระทบด้านเศรษฐกิจ : </p><Card><p className='font-normal'>{Impacts.economy_impacts}</p></Card></>}
            {!Impacts?.academic_impacts && 
             !Impacts?.social_impacts && 
             !Impacts?.public_impacts &&  
             !Impacts?.city_impacts && 
             !Impacts?.environment_impacts && 
             !Impacts?.policy_impacts && 
             !Impacts?.economy_impacts &&
             <>ยังไม่มีการกรอกข้อมูลผลกระทบ</>}
             </Card>
            <br/>
            
            </Card>
            </Card>
            <div
                id="part-5"/>
            <br/>
            <Card style={{ backgroundColor: '#FFDDAE' }}>
            <h2 className="text-2xl font-bold leading-relaxed" style={{display: "flex",color:'#76453B'}}>ส่วนที่ 5 งบประมาณและค่าใช้จ่าย</h2> 
            <br/><hr style={{ height: '1px', backgroundColor: '#B19470', border: 'none' }} /><br/>
            <Card style={{backgroundColor:'white'}}>
            <p className="leading-relaxed font-semibold"><u>งบประมาณ</u></p>
            {DataFirst[0]?.budget_type!='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'&&<Table
                rowKey="id"
                columns={[
                  {
                    title: 'ลำดับที่',
                    width: 92,
                    dataIndex: 'id',
                    key: 'id',
                    render: (_, record) => (
                      <Flex justify="center">
                        <p>{record.id !== 4 ? record.id : ''}</p>
                      </Flex>
                    ),
                  },
                  {
                    title: 'รายละเอียดประมาณการค่าใช้จ่าย',
                    width: 450,
                    dataIndex: 'detail',
                    key: 'detail',
                  },
                  {
                    title: 'งบประมาณ',
                    width: 1000,
                    children: [
                      {
                        title: 'ตัวเงิน(เบิกจ่าย)',
                        width:200,
                        dataIndex: 'MonetrySum',
                        render: (_, record) => (
                          <Flex justify="center">{formatNumber(record.MonetrySum)}</Flex>
                        ),
                      },
                      {
                        title: 'ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้',
                        dataIndex: 'PreparedSum',
                        width:200,
                        render: (_, record) => (
                          <Flex justify="center">{formatNumber(record.PreparedSum)}</Flex>
                        ),
                      },
                      {
                        title: 'ไม่เป็นตัวเงิน(งบอ้อม)',
                        dataIndex: 'IndirectSum',
                        width:200,
                        render: (_, record) => (
                          <Flex justify="center">{formatNumber(record.IndirectSum)}</Flex>
                        ),
                      },
                    ],
                  },
                  {
                    title: 'รวม',
                    width: 150,
                    dataIndex: 'sum',
                    render: (_, record) => (
                      <Flex justify="center">
                        {formatNumber(record.sum)}
                      </Flex>)
                  },
                  {
                    title: 'หมายเหตุ',
                    dataIndex: 'note',
                    key: 'note',
                  },
                ]}
                dataSource={BudgetTypeCol}
                expandable={{
                  expandedRowRender,
                  expandedRowKeys: Keys,
                  onExpand: handleExpand,
                  rowExpandable: (record) => {
                    if (record.category === 'compensation') return compensationItems.length > 0;
                    if (record.category === 'outcome') return OutcomeItems.length > 0;
                    if (record.category === 'itemexpense') return ItemCost.length > 0;
                    return false;
                  },
                }}
                pagination={false}
                locale={{
                  emptyText: <Empty description="ยังไม่มีข้อมูลในตาราง" />,
                }}
                scroll={{ x: 'max-content' }} // Enable horizontal scrolling
              />||
              <Card style={{backgroundColor: '#F7DCB9' }}>
                <Card style={{ marginLeft: 20, marginRight: 20, marginBottom: 25, backgroundColor: 'white', textAlign: 'center', }} >
                  <p>ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา จำนวน 10,000 บาท </p>
                </Card>
              </Card>}
            
            <br/>
            <p className="leading-relaxed font-semibold"><u>บรรณานุกรม</u></p>
            <Card className="transparent-border-card">
                <JoditReact 
                value={DataFirst?.[0]?.reference ? DataFirst[0].reference : "ยังไม่มีการกรอก"} 
                config={config}
                />
            </Card>
            <p className="leading-relaxed font-semibold"><u>ร่างเครื่องมือวิจัย</u></p>
            {toolDraft&& <>
                <List
                    bordered
                    dataSource={fileList}
                    renderItem={(file) => (
                        <List.Item
                    actions={[
                        <>
                        <Button type='link' onClick={() => DownloadHandle(file.uid)}>Download</Button>
                        </>
                    ]}
                    >
                    <Button type='link' 
                    onClick={() => handlePreview(file)}>{file.name}</Button>
                    
                    <Modal
                    onCancel={()=>setOpenFile(false)}
                    style={{ width: '100wh', height: 500 }}
                        open={openfile}
                        footer={<><Button onClick={()=>setOpenFile(false)} >ปิด</Button></>}
                    >
                        {previewUrl ? (
                        <iframe
                            src={previewUrl}
                            width="100%"
                            height="600px"
                            title="PDF Viewer"
                        />
                        ) : (
                        <p>Loading...</p>
                        )}
                        
                    </Modal>
                    </List.Item>
                )}
                />
                </>||
            <p className="leading-relaxed" >*โครงการนี้ไม่มีร่างเครื่องมือวิจัย*</p>
            }
                </Card>
            <br/>
            </Card>
            <FloatButton.Group>
                <FloatButton.BackTop />
               
            </FloatButton.Group>
            <br/>
            <Card style={{ backgroundColor: '#FFDDAE' }}>
              <Card style={{backgroundColor:'white'}}>
                <Form form={submitform}>
                {commentable ? (
                  <Form.Item name="Result" label="ท่านต้องการอนุมัติงานวิจัยหรือไม่">
                    <Radio.Group value={pass} onChange={(e) => setPass(e.target.value)}>
                      <Radio value={1}>อนุมัติ</Radio>
                      <Radio value={2}>ไม่อนุมัติ</Radio>
                    </Radio.Group>
                  </Form.Item>
                ) : (
                  passed ? (
                    <p>ท่านได้อนุมัติโครงการนี้แล้วเมื่อ {moment(StaffCommentDate).utc().format('DD/MM/YYYY HH:mm:ss')}</p>
                  ) : (
                    <p>ท่านได้สั่งแก้โครงการนี้เมื่อ {moment(StaffCommentDate).utc().format('DD/MM/YYYY HH:mm:ss')}</p>
                  )
                )}

                <Form.Item name="Reason" label='เหตุผลประกอบ'>
                    <CKEditors myRef={commentpart1ref}
                      htmlBox={commentpart1}
                      onBlur={handleEditorChange}
                      toolstate={commentable}/>
                </Form.Item>
                {(DataFirst[0]?.project_status=='รอตรวจสอบจากเจ้าหน้าที่สำนักวิจัย'&&pass==1)&&
                <Form.Item name='Expiracy' label='ระยะวันสิ้นสุดการอนุมัติของกรรมการ'>
                  <DatePicker
                    placeholder="กรุณาเลือกวันสิ้นสุดการอนุมัติของกรรมการ"
                    style={{ width: 500 }}
                    disabledDate={(current) => current && current < dayjs().startOf('day')}
                    />
                </Form.Item>
                }
                </Form>
                </Card>
                <br/>
                {pass==1&&<Card style={{backgroundColor:'white'}}>
                <p className='font-semibold' style={{marginBottom:20}}><u>รายชื่อกรรมการ</u></p>
                {!ShowCommittee && <><Card style={{marginBottom:20}}>
                <List
                  dataSource={Committeeandcomment}
                  renderItem={(item) => {
                    // Find the facility by Fac_ID
                    const facility = Fac.find((fac) => Number(fac.Fac_ID) === Number(item.Fac_ID));
                    
                    return (
                      <List.Item key={item?.committee_id}>
                        <List.Item.Meta
                          title={<p>{item?.committee_name}</p>}
                          description={<div>{facility ? facility.Fac_NameTH : 'Facility Not Found'}</div>}
                        />
                        <div><Button danger type='primary' onClick={()=>
                        {
                          setCommitteeandcomment(Committeeandcomment.filter((ori) => ori.committee_id !== item.committee_id))
                          axios.delete(`${process.env.REACT_APP_BASE}/deletedcommittee/${project_id}/${item.committee_id}`)
                        }}>ลบข้อมูล</Button></div>
                      </List.Item>
                    );
                  }}
                  locale={{
                    emptyText: <Empty description="ไม่มีข้อมูลรายละเอียด" />, 
                  }}
                />
                </Card>
                <Form.Item label='คณะที่ท่านต้องการค้นหา'>
                <Select
                  showSearch
                  style={{ width: 500 }}
                  value={SelectedOp}
                  onChange={handleChange}
                  options={Fac.map((Fac) => ({
                    value: Fac.Fac_ID,
                    label: Fac.Fac_NameTH,
                    key: Fac.Fac_NameTH,
                  }))}
                  placeholder="โปรดเลือกคณะ"
                  filterOption={(input, option) =>
                    (option?.label as string).toLowerCase().includes(input.toLowerCase())
                  }
                />
                </Form.Item>
                <Form.Item label='คณะกรรมการที่ต้องการให้ตรวจสอบงานวิจัยนี้'>
                <Select
                  showSearch
                  style={{ width: 500 }}
                  value = {commit}
                  onChange={handleCommitChange}
                  options={ResOp.map((ResOp) => ({
                  value: ResOp.WK_ID,
                  label: ResOp.Per_PrefixTH +` ` +ResOp.Per_FNameTH + ` ` + ResOp.Per_LNameTH,
                  key: ResOp.Per_PrefixTH +` ` +ResOp.Per_FNameTH + ` ` + ResOp.Per_LNameTH,
                }
              ))}
                filterOption={(input, option) =>
                  (option?.label as string)
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                placeholder="โปรดเลือกบุคลากร"
                />
                </Form.Item>
                
                <Flex justify='end'>
                  <Button type='primary' onClick={()=>handleAdd()}>เพิ่มข้อมูลคณะกรรมการ</Button></Flex>
                  </>||<>
                  <Card style={{marginBottom:20}}>
                <List
                  dataSource={Committeeandcomment}
                  renderItem={(item) => {
                    // Find the facility by Fac_ID
                    const facility = Fac.find((fac) => Number(fac.Fac_ID) === Number(item.Fac_ID));
                    
                    return (
                      <List.Item key={item?.committee_id}>
                        <List.Item.Meta
                          title={<p>{item?.committee_name}</p>}
                          description={<div>{facility ? facility.Fac_NameTH : 'Facility Not Found'}</div>}
                        />
                      </List.Item>)
                    }}
                />
                </Card>
                  </>
                  }
                </Card>
                }
            </Card>
            <br/>
            {

            }
            <Form form={form}>
            {showCommitteeCommentStatus&&<>
            <Card style={{ backgroundColor: '#FFDDAE' }}>
              <p className='font-semibold text-2xl ' style={{display: "flex",color:'#76453B'}} >
                สถานะการอนุมัติของคณะกรรมการ
              </p>
              <br/>
              <hr  style={{ height: '1px', backgroundColor: '#B19470', border: 'none' }} />
              <br/>
              <Card style={{ backgroundColor: 'white' }}>
                <Flex><p className='font-semibold'>วันสิ้นสุดการอนุมัติ : </p>&nbsp;<p>
                  {moment(expireDate).format('DD/MM/YYYY')}
                    </p></Flex>
                    <br/>
                  <Button onClick={()=>setOpenDateMod(true)}>เปลี่ยนวันอนุมัติ</Button>
              </Card>
              <Modal
              title='เปลี่ยนวันอนุมัติ'
              open={openDateMod}
              width={'40vw'}
              onCancel={()=>setOpenDateMod(false)}
              footer={[
                <><Button key="back" onClick={()=>setOpenDateMod(false)}>
                    ยกเลิก
                </Button><Button type='primary' onClick={() => ChangeDate()}>
                    เปลี่ยนวันอนุมัติ
                </Button></>
              ]}
              centered
              >
                <hr/>
                <br></br>
                <Card style={{ backgroundColor: 'white' }}>
                <Flex><p className='font-semibold'>วันสิ้นสุดการอนุมัติเดิม : </p>&nbsp;<p>
                  {moment(expireDate).format('DD/MM/YYYY')}
                    </p></Flex>
              </Card>
                <br/>
                <Form.Item name='newReviewDate' label="กรุณาเลือกวันที่ต้องการเปลี่ยน">
                  <DatePicker placeholder='กรุณาเลือกวันสิ้นสุดการอนุมัติ'
                  />
                </Form.Item>
              </Modal>
              {
                Committeeandcomment.map((committee,index)=>(
                  <><br/>
                  <Card  style={{ backgroundColor: 'white' }}>
                    <Flex><p className='font-semibold'>ชื่อกรรมการ : </p>&nbsp;<p>
                    {committee.committee_name}</p></Flex>
                    <Flex>
                      <p className='font-semibold'>ผลการอนุมัติ : </p>&nbsp;{committee.result&&<p style={{color:'green'}}>ส่งผลอนุมัติแล้ว</p>
                    ||
                    <p style={{color:'red'}}>ยังไม่ส่งผลอนุมัติ</p>}
                    </Flex>
                    {committee.comment&&<>
                    <br/>
                      <Table 
                       pagination={false}
                        columns={[
                          {
                            title: 'ข้อ',
                            key: 'index',
                            width: 50,
                            dataIndex: 'index',
                            render: (text, record, index) => index + 1 // Increment index by 1
                          },
                        {
                          title: 'หัวข้อที่ประเมิน',
                          key: 'Topic',
                          width:300,
                          dataIndex: 'Topic', // Add dataIndex for rendering
                        },
                        {
                          title: 'ข้อเสนอแนะ',
                          key: 'Comment',
                          dataIndex: 'Comment',}
                          ]}
                          dataSource={JSON.parse(committee.comment)}/>
                      </>}
                    
                  </Card></>
                ))
              }
            </Card>
            </>}
            {showCommitteeComment 
            && <><Card style={{ backgroundColor: '#FFDDAE' }}>
              <p className='font-semibold text-2xl ' style={{display: "flex",color:'#76453B'}} ><u>รวมผลตรวจสอบจากคณะกรรมการ</u></p>
              <br/>
              {Committeeandcomment.map((committee, index) => (
                <Card key={index} style={{ backgroundColor: 'white', marginBottom: '1rem' }}>
                  <Flex><p className='font-semibold'>ชื่อกรรมการ : </p>&nbsp;<p>
                    {committee.committee_name}</p></Flex>
                    <Flex><p className='font-semibold'>ผลการอนุมัติ : </p>&nbsp;{committee.result&&<p>{committee.result}</p>||<p style={{color:'red'}}>ไม่ได้ยื่นผล</p>}</Flex>
                </Card>
              ))}

              <br/>
              
              <Card style={{ backgroundColor: 'white', marginBottom: '1rem' }}>
              {DataFirst[0].project_status=='รอตรวจสอบผลแก้ไขจากเจ้าหน้าที่'&&<>
                <p className='font-semibold'><u>รายละเอียดข้อเสนอแนะ</u></p>
                <Table
                  columns={ [
                    {
                      title:'ข้อ',
                      dataIndex: 'index',
                      fixed: 'left',  
                      className: 'fixed-column',
                      width:100,
                      key: 'index',
                    },
                    {
                      title: 'หัวข้อ',
                      dataIndex: 'topic',
                      fixed: 'left',  
                      className: 'fixed-column',
                      width:200,
                      key: 'topic',
                    },
                    ...Committeeandcomment.map((committee, index) => ({
                      title: committee.committee_name.trim(),
                      dataIndex: `committee_${index}`,
                      width: 300,
                      key: `committee_${index}`,
                      render: (value: { result: string; comment: string }) => (
                        <div style={{ wordWrap: 'break-word', wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>
                          {value.comment!=''&&<p>
                            {value.comment} 
                          </p>|| <p>-</p>}
                        </div>
                      ),
                    })),
                    {
                      title: 'ผลสรุปข้อเสนอแนะ',
                      dataIndex:'committee_summary',
                      render: (_, record,index) => {
                        // Aggregate comments from all committees
                
                        return (
                            <Form.Item
                              name={['summary', index]}
                              initialValue={record.Reccommendation} // Bind summary to Form.Item
                              style={{ marginBottom: 0 }}
                            >
                              <TextArea
                                autoSize
                              />
                            </Form.Item>
                            
                        );
                      },
                    },
                    {
                      title: 'คำชี้แจงจากนักวิจัย',
                      dataIndex: 'explanation',
                      render: (_, record, index) => {
                        const explanation = exp?.[index]?.explanation;
                        return (
                          <>
                           {
                              researchercomment?.[index]?.explanation ? (
                                <p>{researchercomment[index].explanation}</p>
                              ) : (
                                <p>
                                  {explanation?.trim()
                                    ? explanation
                                    : 'ไม่มีคำชี้แจ้งจากนักวิจัย'}
                                </p>
                              )
                            }
                          </>
                        );
                      },
                    }
                  ]}
                  dataSource={CommentSum}
                  scroll={{ y: 500,
                    x: 'max-content' }}
                  pagination={false}
                />
              </>||
                <><p className='font-semibold'><u>รายละเอียดข้อเสนอแนะ</u></p>
                <Table
                  columns={ [
                    {
                      title:'ข้อ',
                      dataIndex: 'index',
                      fixed: 'left',  
                      className: 'fixed-column',
                      width:100,
                      key: 'index',
                    },
                    {
                      title: 'หัวข้อ',
                      dataIndex: 'topic',
                      fixed: 'left',  
                      className: 'fixed-column',
                      width:200,
                      key: 'topic',
                    },
                    ...Committeeandcomment.map((committee, index) => ({
                      title: committee.committee_name.trim(),
                      dataIndex: `committee_${index}`,
                      width: 300,
                      key: `committee_${index}`,
                      render: (value: { result: string; comment: string }) => (
                        <div style={{ wordWrap: 'break-word', wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>
                          {value.comment!=''&&<p>
                            {value.comment} 
                          </p>|| <p>-</p>}
                        </div>
                      ),
                    })),
                    {
                      title: 'ผลสรุปข้อเสนอแนะ',
                      dataIndex:'committee_summary',
                      render: (_, record,index) => {
                        // Aggregate comments from all committees
                
                        return (
                          <>{DataFirst[0].project_status=='รอการตรวจสอบผลอนุมัติจากกรรมการ'&&
                            <>
                            <Form.Item
                              name={['summary', index]}
                              initialValue={record.committee_summary} // Bind summary to Form.Item
                              style={{ marginBottom: 0 }}
                            >
                              <TextArea
                                autoSize
                                disabled={DataFirst[0].project_status !== 'รอการตรวจสอบผลอนุมัติจากกรรมการ'}
                              />
                            </Form.Item>
                         
                            </>
                            ||<p>{summary[index]}</p>}
                             </>
                        );
                      },
                    }
                  ]}
                  dataSource={CommentSum}
                  scroll={{ y: 500,
                    x: 'max-content' }}
                  pagination={false}
                /></>}
              </Card>
             
              <br/>
              <Flex justify='end'>
              {DataFirst[0].project_status=='รอการตรวจสอบผลอนุมัติจากกรรมการ'&&<Button style={{backgroundColor:'#33b249',color:'white',borderColor:'#33b249'}} onClick={Draft}>บันทึกร่างคำตอบ</Button>}
              </Flex>
              <br/>
              {!isCommitted && <><Card style={{ backgroundColor: 'white' }}>
                <Form.Item label="ผลการอนุมัติของโครงการนี้คือ"> 
                <Radio.Group value={wholepass} onChange={(e) => setwholepass(e.target.value)}>
                      <Radio value={1}>อนุมัติ</Radio>
                      <Radio value={2}>ไม่อนุมัติ</Radio>
                      <Radio value={3}>แก้ไข</Radio>
                    </Radio.Group>
                </Form.Item>
              </Card></>||<>
              <Card style={{backgroundColor:'white'}}>
                <p>ผลของโครงการนี้คือ {result}</p>
              </Card></>}
              
            </Card>
            
            </>
            }
            <br/>
            {(DataFirst[0]?.project_status == 'รอตรวจสอบจากเจ้าหน้าที่สำนักวิจัย'|| DataFirst[0]?.project_status == 'รอการตรวจสอบผลอนุมัติจากกรรมการ')&&
            <>
            <Flex justify='center'>
              <Button onClick={()=>{
              setLoading(true);
              handleSetEditor()
              
              }}>สร้างไฟล์ PDF / WORD</Button></Flex>
              </>}
            
            <br/>
            <Flex justify="space-between" align="center">
            {/* Left Section */}
            <Button onClick={() => navigate('/VRIIS')}>กลับ</Button>

            {/* Middle Section */}
            <Flex justify="center" >
              {DataFirst[0]?.project_status === 'รอการตรวจสอบผลอนุมัติจากกรรมการ' && (
                <Button onClick={() => setOpenReview(true)}>ขยายเวลาการอนุมัติ</Button>
              )}
              {DataFirst[0]?.project_status === 'รอผลอนุมัติจากคณะกรรมการ' && (
                <Button onClick={() => setOpen(true)}>ดึงผลการอนุมัติกลับ</Button>
              )}
               {DataFirst[0]?.project_status === 'แก้ไขตามความเห็นของกรรมการ' &&
              (<><Button danger onClick={()=>setDeclineOpen(true)}>ไม่อนุมัติ</Button></>)}
            </Flex>
            <Modal
              open={DeclineOpen}
              onCancel={() => setDeclineOpen(false)}
              footer={null}
              centered
              width={500}
          >
              <Flex
                  vertical
                  align="center"
                  gap="large"
                  style={{ padding: '20px 10px' }}
              >

                  <div
                      style={{
                          width: 72,
                          height: 72,
                          borderRadius: '50%',
                          background: '#fff2f0',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          fontSize: '36px'
                      }}
                  >
                      ⚠️
                  </div>

                  <Flex vertical align="center" gap="small">
                      <div
                          style={{
                              fontSize: '24px',
                              fontWeight: 700,
                              color: '#cf1322'
                          }}
                      >
                          ไม่อนุมัติโครงการ
                      </div>

                      <div
                          style={{
                              textAlign: 'center',
                              color: '#595959',
                              lineHeight: 1.7,
                              fontSize: '15px',
                              maxWidth: '380px'
                          }}
                      >
                          คุณต้องการไม่อนุมัติโครงการนี้หรือไม่
                          <br />
                          หากดำเนินการแล้ว จะไม่สามารถเปลี่ยนสถานะของโครงการนี้ได้อีก
                      </div>
                  </Flex>

                  <Flex
                      justify="center"
                      gap="middle"
                      style={{ width: '100%', marginTop: '10px' }}
                  >
                      <Button
                          size="large"
                          style={{ minWidth: '120px' }}
                          onClick={() => setDeclineOpen(false)}
                      >
                          ยกเลิก
                      </Button>

                      <Button
                          danger
                          type="primary"
                          size="large"
                          style={{ minWidth: '120px' }}
                          onClick={()=>declingProject()}
                      >
                          ยืนยันการไม่อนุมัติ
                      </Button>
                  </Flex>
              </Flex>
          </Modal>

            {/* Right Section */}
            <Flex>
              {(commentable || last) && (
                <Button type="primary" onClick={() => setopenMod(true)}>
                  ยื่นผลการอนุมัติ
                </Button>
              )}
              {DataFirst[0]?.project_status !== 'รอตรวจสอบจากเจ้าหน้าที่สำนักวิจัย' &&
                DataFirst[0]?.project_status !== 'รอการตรวจสอบผลอนุมัติจากกรรมการ' && (
                  <Button onClick={() => handleSetEditor()}>สร้างไฟล์ PDF / WORD</Button>
                )}
            </Flex>
          </Flex>

          <Modal
          open={openReview}
          onCancel={()=>setOpen(false)}
          onOk={()=>submit()}
          title="เปิดระบบอนุมัติจากคณะกรรมการ"
          footer={[
            <><Button key="back" onClick={()=>setOpen(false)}>
                กลับ
            </Button><Button type='primary' onClick={() => OpenReviewAgain()}>
                ใช่
            </Button></>
          ]}
          centered>
             <p>หากท่านยืนยันจะเป็นการเปลี่ยนสถานะของโครงการจาก </p>
              <br/>
              <p style={{color:'blue'}}>" รอการตรวจสอบผลอนุมัติจากกรรมการ " </p> 
              <Flex>
               <p>เป็น</p> &nbsp; <p style={{color:'purple'}}>" รอผลอนุมัติจากคณะกรรมการ "</p></Flex>
               <br/>
              <p>คณะกรรมการที่ยังไม่ทำการอนุมัติจะสามารถเพิ่มทำการอนุมัติได้</p>
              <p>ท่านต้องการเปิดรับผลการพิจารณาผลจากคณะกรรมการอีกครั้งหรือไม่</p>
              

          </Modal>


            <Modal
            open={open}
            onCancel={()=>setOpen(false)}
            onOk={()=>submit()}
            title="ยุติการพิจารณาจากคณะกรรมการ"
            footer={[
              <><Button key="back" onClick={()=>setOpen(false)}>
                  กลับ
              </Button><Button type='primary' onClick={() => EndReview()}>
                  ใช่
              </Button></>
            ]}
            centered>
              <p>หากท่านยืนยันจะเป็นการเปลี่ยนสถานะของโครงการจาก </p>
              <br/>
              <p style={{color:'purple'}}>" รอผลอนุมัติจากคณะกรรมการ " </p> 
              <Flex>
               <p>เป็น</p> &nbsp; <p style={{color:'blue'}}>" รอการตรวจสอบผลอนุมัติจากกรรมการ "</p></Flex>
               <br/>
               <p>คณะกรรมการที่ยังไม่ทำการอนุมัติจะถูกแสดงผลว่าอนุมัติโครงการแล้ว</p>
              <p>ท่านต้องการยุติการพิจารณาผลจากคณะกรรมการหรือไม่</p>
            </Modal>
            
            <Modal
            open={openMod}
            onCancel={()=>setopenMod(false)}
            onOk={()=>submit()}
            centered
            footer={[
                <><Button key="back" onClick={()=>setopenMod(false)}>
                    กลับ
                </Button><Button type='primary' onClick={() => submit()}>
                    ใช่
                </Button></>
              ]}
            >
                {<p>คุณต้องการยืนยันผลอนุมัติหรือไม่</p>}
            </Modal>
            
            </Form>
              <Modal
                title='ตัวอย่างข้อมูลในไฟล์'
                open={preview}
                width={'70vw'}
                bodyStyle={{
                  maxHeight: "70vh", 
                  overflowY: "auto",  
                }}
                onCancel={()=>setPreview(false)}
                footer={<></>}>
                <LoadingOverlay active={PreviewLoading} 
                    spinner
                    text='กำลังโหลดข้อมูล'>
                  <CKEditors myRef={htmlpage} htmlBox={exportdata} onBlur={handleEditorChange} toolstate={true}/>
                </LoadingOverlay>
              </Modal>
            
            
        </div></LoadingOverlay></>

    )
}